function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362,338l-.07-.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,363.52a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,367.85,363.52Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,356a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,367.85,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.85,348.43a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,367.85,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3,345.27l.46.46A1.2,1.2,0,0,1,369.3,345.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.63,367.29a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,371.63,367.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.63,359.75a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,371.63,359.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.37,
    cy: 352.2,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,348.93l.65.66A1.27,1.27,0,0,1,373,348.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.4,363.52a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,375.4,363.52Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.4,356a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,375.4,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.75,352.65l.72.72A1.27,1.27,0,0,1,376.75,352.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.17,367.29a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,379.17,367.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.17,359.75a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,379.17,359.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.51,356.38l.79.77A1.26,1.26,0,0,1,380.51,356.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,371.07a.73.73,0,0,1-.05.2l-1.13-.2-.08,0-1.21-.22a1.23,1.23,0,0,1,1.21-1A1.26,1.26,0,0,1,383,371.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.69,
    cy: 363.52,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.28,360.1l.84.83A1.21,1.21,0,0,1,384.28,360.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.72,367.29a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,386.72,367.29Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,363.83l.9.89A1.25,1.25,0,0,1,388,363.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,371.07a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,390.49,371.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.8,367.56l1,.94A1.23,1.23,0,0,1,391.8,367.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,372.28a1.22,1.22,0,0,1-1-1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.58,348.43a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,322.58,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.32,
    cy: 340.88,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.58,333.33a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,322.58,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.58,325.79a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,322.58,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.58,318.24a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,322.58,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.58,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,322.58,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.32,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,352.2a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,326.35,352.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,344.65a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,326.35,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,337.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,326.35,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,329.56a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,326.35,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,326.35,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,326.35,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,326.35,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,359.75a1.24,1.24,0,0,1-.75,1.14l-1.39-.25a1.26,1.26,0,1,1,2.14-.89Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,356a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,330.12,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,348.43a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,330.12,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,340.88a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,330.12,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,330.12,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,330.12,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,330.12,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.12,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,330.12,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,359.75a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,333.89,359.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,352.2a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,333.89,352.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,344.65a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,333.89,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,337.11a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,333.89,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,333.89,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,333.89,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.89,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,333.89,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.58,363.06l-1.17-.21-.92-.17a1.25,1.25,0,0,1,.92-.42A1.28,1.28,0,0,1,337.58,363.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,356a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,337.67,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,348.43a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,337.67,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.41,
    cy: 340.88,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,337.67,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,337.67,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,337.67,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,359.75a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,341.44,359.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,352.2a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,341.44,352.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,344.65a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,341.44,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,337.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,341.44,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,329.56a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,341.44,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,341.44,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,363.52a1.2,1.2,0,0,1-.35.86l-.9-.16L342.8,364a1.34,1.34,0,0,1-.1-.49,1.26,1.26,0,1,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,356a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,345.21,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,348.43a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,345.21,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,340.88a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,345.21,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,333.33a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,345.21,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,345.21,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,359.75a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,349,359.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.73,
    cy: 352.2,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,344.65a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,349,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,337.11a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,349,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.73,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.76,363.52a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,352.76,363.52Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.76,356a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,352.76,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.76,348.43a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,352.76,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.76,340.88a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,352.76,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.76,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,352.76,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.53,359.75a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,356.53,359.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.53,352.2a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,356.53,352.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.53,344.65a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,356.53,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.53,337.11a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,356.53,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28,366a1.23,1.23,0,0,1,.9.39l-1.44-.26A1.2,1.2,0,0,1,355.28,366Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.05,
    cy: 363.52,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.31,356a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,360.31,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.31,348.43a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,360.31,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.05,
    cy: 340.88,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.08,359.75a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,364.08,359.75Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.08,352.2a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,364.08,352.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.08,344.65a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,364.08,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.08,367.29a1.28,1.28,0,0,1-.14.55l-2.35-.43s0-.08,0-.12a1.26,1.26,0,0,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,296.16,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,296.16,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,296.16,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,284.28a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,296.16,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,296.16,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,356a1,1,0,0,1-.06.26l-1.2-.21-.23,0-1-.18a1.24,1.24,0,0,1,1.22-1.07A1.26,1.26,0,0,1,299.94,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,348.43a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,299.94,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.68,
    cy: 340.88,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,333.33a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,299.94,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,325.79a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,299.94,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,318.24a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,299.94,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,299.94,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.68,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,299.94,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.94,288.06a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,299.94,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.68,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,352.2a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,303.71,352.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,344.65a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,303.71,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,337.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,303.71,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,329.56a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,303.71,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,303.71,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,303.71,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,303.71,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,303.71,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,303.71,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,303.71,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,356a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,307.48,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,348.43a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,307.48,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,340.88a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,307.48,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,333.33a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,307.48,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,307.48,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,307.48,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,307.48,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,307.48,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,307.48,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,307.48,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 352.2,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.26,344.65A1.26,1.26,0,1,1,310,343.4,1.26,1.26,0,0,1,311.26,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.26,337.11a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,311.26,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.26,322a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,311.26,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.26,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,311.26,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.26,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,311.26,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,356a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,315,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,348.43a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,315,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,340.88a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,315,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,315,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,315,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,315,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,315,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,315,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,315,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,352.2a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,318.8,352.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,344.65a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,318.8,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,337.11a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,318.8,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,318.8,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,318.8,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,318.8,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,318.8,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,318.8,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78,359.66l-2.37-.43a1.24,1.24,0,0,1,2.37.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.58,356a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,322.58,356Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,348.43a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,277.3,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.04,
    cy: 340.88,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,333.33a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,277.3,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,325.79a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,277.3,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,318.24A1.26,1.26,0,1,1,276,317,1.26,1.26,0,0,1,277.3,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,277.3,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.04,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,277.3,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,288.06A1.26,1.26,0,1,1,276,286.8,1.26,1.26,0,0,1,277.3,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.04,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,273a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,277.3,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,265.42a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,277.3,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,257.87a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,277.3,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,344.65a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,281.07,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,337.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,281.07,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,329.56a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,281.07,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,281.07,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,281.07,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,281.07,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,281.07,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,281.07,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,281.07,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,281.07,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,281.07,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,281.07,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,352.2a1.16,1.16,0,0,1-.17.59l-2.31-.41a1.13,1.13,0,0,1,0-.18,1.26,1.26,0,1,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,348.43a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,284.84,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,340.88a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,284.84,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,333.33a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,284.84,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,284.84,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,284.84,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,284.84,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,284.84,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,284.84,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,284.84,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,284.84,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,284.84,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.84,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,284.84,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.36,
    cy: 352.2,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,344.65a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,288.62,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,337.11a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,288.62,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.36,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,322a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,288.62,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.36,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,288.62,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,288.62,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.36,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,284.28a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,288.62,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.62,276.74a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,288.62,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.36,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,348.43a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,292.39,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,340.88a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,292.39,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,292.39,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,292.39,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,292.39,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,292.39,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,292.39,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,292.39,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,292.39,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,292.39,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,292.39,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,352.2a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,296.16,352.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,344.65a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,296.16,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,337.11a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,296.16,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,296.16,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,296.16,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.16,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,296.16,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,254.66,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,254.66,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,235.23A1.26,1.26,0,1,1,253.4,234,1.25,1.25,0,0,1,254.66,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,344.65a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,258.43,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,337.11a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,258.43,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,258.43,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,258.43,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,258.43,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,258.43,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,258.43,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,258.43,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,284.28a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,258.43,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,258.43,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,258.43,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,258.43,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,258.43,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,246.55a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,258.43,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.43,239a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,258.43,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,348.43a1.25,1.25,0,0,1-.39.91l-.86-.16-1.12-.2a1.28,1.28,0,0,1-.14-.55,1.26,1.26,0,1,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,340.88a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,262.2,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,333.33a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,262.2,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,262.2,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,318.24A1.26,1.26,0,1,1,261,317,1.25,1.25,0,0,1,262.2,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,262.2,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,262.2,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,262.2,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,288.06A1.26,1.26,0,1,1,261,286.8,1.25,1.25,0,0,1,262.2,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,262.2,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,262.2,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,262.2,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,262.2,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,262.2,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,262.2,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,344.65a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,266,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,337.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,266,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.72,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,266,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.72,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,266,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,266,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.72,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,266,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,266,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.72,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,266,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.72,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,266,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,348.43a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,269.75,348.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,340.88a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,269.75,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,269.75,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,269.75,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,269.75,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,269.75,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,269.75,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,269.75,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,269.75,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,269.75,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,269.75,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,269.75,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,269.75,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,269.75,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,344.65a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,273.52,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,337.11a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,273.52,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,273.52,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,273.52,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,273.52,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,273.52,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,273.52,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,273.52,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,284.28a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,273.52,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,273.52,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,273.52,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,273.52,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,273.52,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.27,350.94a1.26,1.26,0,0,1,1,.46l-1.56-.28A1.25,1.25,0,0,1,272.27,350.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,273a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,239.57,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,265.42a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,239.57,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,257.87a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,239.57,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,250.33a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,239.57,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.31,
    cy: 242.78,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,235.23a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,239.57,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,227.69a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,239.57,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.31,
    cy: 220.14,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,337.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,243.34,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,329.56a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,243.34,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,243.34,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,243.34,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,243.34,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,243.34,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,243.34,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,243.34,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,243.34,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,243.34,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,243.34,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,254.1a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,243.34,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,243.34,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,243.34,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,231.46a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,243.34,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,243.34,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,344.65a1.24,1.24,0,0,1-.87,1.18l-1.15-.21a1.21,1.21,0,0,1-.49-1,1.26,1.26,0,0,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,340.88a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,247.11,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,333.33a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,247.11,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,247.11,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,247.11,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,247.11,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,247.11,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,247.11,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,247.11,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,247.11,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,247.11,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,247.11,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,247.11,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,247.11,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,247.11,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,235.23a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,247.11,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,227.69a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,247.11,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,344.65a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,250.89,344.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,337.11a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,250.89,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.63,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,322a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,250.89,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.63,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,250.89,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,250.89,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.63,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,284.28a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,250.89,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,276.74a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,250.89,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.63,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,261.65a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,250.89,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.63,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,246.55a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,250.89,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,239a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,250.89,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.63,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.58,348l-1.18-.22-1-.17a1.22,1.22,0,0,1,1-.47A1.25,1.25,0,0,1,254.58,348Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,340.88a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,254.66,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,254.66,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,254.66,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,318.24A1.26,1.26,0,1,1,253.4,317,1.25,1.25,0,0,1,254.66,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,254.66,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,254.66,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,254.66,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,254.66,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,254.66,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,254.66,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,254.66,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,254.66,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,235.23a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,224.47,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,227.69a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,224.47,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,220.14a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,224.47,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,212.59a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,224.47,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,205.05a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,224.47,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,337.11a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,228.25,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.99,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,322a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,228.25,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.99,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,228.25,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,228.25,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.99,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,284.28A1.26,1.26,0,1,1,227,283,1.26,1.26,0,0,1,228.25,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,276.74a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,228.25,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.99,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,261.65a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,228.25,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.99,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,246.55A1.26,1.26,0,1,1,227,245.3,1.26,1.26,0,0,1,228.25,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,239a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,228.25,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.99,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,223.91a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,228.25,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,216.37a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,228.25,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.99,
    cy: 208.82,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,340.88a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,232,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,232,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,232,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,232,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,232,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,232,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,232,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,232,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,232,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,232,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,232,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,232,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,232,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,232,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,235.23a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,232,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,227.69a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,232,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,220.14a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,232,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,212.59a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,232,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,337.11a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,235.79,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,235.79,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,235.79,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,284.28a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,235.79,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,235.79,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,246.55a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,235.79,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,239a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,231.46a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,235.79,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,223.91a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,235.79,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,216.37a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,235.79,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.79,344.62l-2.42-.43a1.25,1.25,0,0,1,2.42.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.31,
    cy: 340.88,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,333.33a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,239.57,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,325.79a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,239.57,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,318.24a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,239.57,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,239.57,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.31,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,239.57,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.57,288.06a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,239.57,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.31,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,231.46a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,213.15,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,223.91a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,213.15,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,216.37a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,208.82a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,201.27A1.26,1.26,0,1,1,211.9,200,1.25,1.25,0,0,1,213.15,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,193.73a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,213.15,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,340.88a1.23,1.23,0,0,1-.07.32l-1.19-.22-.54-.1-.69-.12a1.25,1.25,0,0,1,1.23-1.14A1.27,1.27,0,0,1,216.93,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,333.33a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,216.93,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,325.79a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,216.93,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,318.24a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,216.93,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,216.93,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.67,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,216.93,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,288.06a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,216.93,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.67,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,273a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,216.93,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,265.42a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,216.93,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,257.87a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,216.93,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,250.33a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,216.93,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.67,
    cy: 242.78,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,235.23a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,216.93,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,227.69a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,216.93,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.67,
    cy: 220.14,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,212.59a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,216.93,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,205.05a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,216.93,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.93,197.5a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,216.93,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,337.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,329.56a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,220.7,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,220.7,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,220.7,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,220.7,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,254.1a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,220.7,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,220.7,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,231.46a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,220.7,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,220.7,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,216.37a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,208.82a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,220.7,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.7,201.27a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,220.7,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,340.88a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,224.47,340.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,333.33a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,224.47,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,224.47,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,224.47,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,224.47,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,224.47,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,224.47,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,224.47,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,224.47,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,224.47,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,224.47,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,224.47,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,224.47,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.47,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,224.47,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,333.33a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,201.83,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,201.83,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,201.83,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,201.83,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,201.83,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,201.83,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,201.83,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,201.83,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,201.83,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,201.83,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,201.83,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,201.83,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,201.83,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,235.23a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,201.83,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,227.69a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,201.83,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,220.14a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,201.83,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,212.59a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,201.83,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,205.05a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,201.83,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,197.5a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,201.83,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,190a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,201.83,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.83,182.41a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,201.83,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,337.11a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,205.61,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.35,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,205.61,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.35,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,205.61,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,205.61,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.35,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,205.61,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,205.61,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.35,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,205.61,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.35,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,205.61,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,205.61,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.35,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,205.61,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,216.37a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,205.61,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.35,
    cy: 208.82,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,201.27a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,205.61,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.35,
    cy: 193.73,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,186.18a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,205.61,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,209.38,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,209.38,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,209.38,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,209.38,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,209.38,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,209.38,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,209.38,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,209.38,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,209.38,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,209.38,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,209.38,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,209.38,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,209.38,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,235.23a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,209.38,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,227.69a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,209.38,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,220.14a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,209.38,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,212.59a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,209.38,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,205.05a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,209.38,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,197.5a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,209.38,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,190a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,209.38,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,337.11a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,337.11Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,213.15,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,213.15,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,213.15,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,284.28A1.26,1.26,0,1,1,211.9,283,1.25,1.25,0,0,1,213.15,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,213.15,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,246.55a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,213.15,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.15,239a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,213.15,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,190a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,182.41a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,186.74,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,174.86a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,167.32a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,322a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,190.52,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,190.52,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,190.52,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,284.28a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,190.52,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,276.74a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,190.52,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,261.65a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,190.52,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,246.55a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,190.52,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,239a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,190.52,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,223.91a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,190.52,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,216.37a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,190.52,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 208.82,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,201.27a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,190.52,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 193.73,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,186.18a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,190.52,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.52,178.64a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,190.52,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.26,
    cy: 171.09,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.25,336.37l-1.66-.3a1.19,1.19,0,0,1,.67-.22A1.26,1.26,0,0,1,190.25,336.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,333.33a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,194.29,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,194.29,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,318.24A1.26,1.26,0,1,1,193,317,1.25,1.25,0,0,1,194.29,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,194.29,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,194.29,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,194.29,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,288.06A1.26,1.26,0,1,1,193,286.8,1.25,1.25,0,0,1,194.29,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,194.29,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,194.29,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,194.29,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,194.29,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,194.29,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,194.29,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,235.23A1.26,1.26,0,1,1,193,234,1.25,1.25,0,0,1,194.29,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,227.69a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,194.29,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,220.14a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,194.29,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,212.59a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,194.29,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,205.05a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,194.29,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,197.5a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,194.29,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,190A1.26,1.26,0,1,1,193,188.7,1.25,1.25,0,0,1,194.29,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,182.41a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,194.29,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,174.86a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,194.29,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,198.06,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,198.06,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,198.06,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,284.28a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,198.06,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,198.06,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,246.55a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,198.06,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,239a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,231.46a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,198.06,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,223.91a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,198.06,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,216.37a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,208.82a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,201.27a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,198.06,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,193.73a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,198.06,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,186.18a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,198.06,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,178.64a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,198.06,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.06,337.11a1.18,1.18,0,0,1-.2.64l-2.26-.41a1,1,0,0,1,0-.23,1.26,1.26,0,1,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,333.33a1.24,1.24,0,0,1-.47,1l-.79-.15-1.07-.19a1.19,1.19,0,0,1-.19-.62,1.26,1.26,0,0,1,2.52,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,325.79a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,318.24a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,179.2,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.94,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,179.2,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,288.06a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.94,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,273a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,179.2,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,265.42a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,257.87a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,179.2,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,250.33a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.94,
    cy: 242.78,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,235.23a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,179.2,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,227.69a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.94,
    cy: 220.14,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,212.59a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,179.2,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,205.05a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,197.5a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,179.2,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,190a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.94,
    cy: 182.41,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,174.86a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,179.2,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,167.32a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,179.2,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.94,
    cy: 159.77,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,329.56a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,183,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,183,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,183,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,183,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,254.1a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,183,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,183,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,231.46a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,183,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,183,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,216.37a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,208.82a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,201.27a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,183,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,193.73a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,183,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,186.18a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,183,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,178.64a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,183,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,171.09a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,183,171.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,163.54a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,183,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,333.33a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,333.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,186.74,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,186.74,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,186.74,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,235.23a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,227.69a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,220.14a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,186.74,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,212.59a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,205.05a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,186.74,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.74,197.5a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,186.74,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,246.55a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,167.88,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,239a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,167.88,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,223.91a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,167.88,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,216.37a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,167.88,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 208.82,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,201.27a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,167.88,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 193.73,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,186.18a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,167.88,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,178.64a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,167.88,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 171.09,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,163.54a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,167.88,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,156a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,167.88,156Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 148.45,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.58,333l-1.19-.21-1-.18a1.22,1.22,0,0,1,2.18.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,171.65,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,171.65,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,171.65,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,235.23a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,227.69a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,220.14a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,171.65,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,212.59a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,205.05a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,197.5a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,190a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,182.41a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,171.65,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,174.86a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,167.32a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,171.65,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,159.77a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,171.65,159.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,152.22a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,171.65,152.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,329.56a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,329.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,175.42,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,175.42,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,175.42,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,284.28a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,175.42,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,175.42,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,246.55a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,175.42,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,239a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,231.46a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,175.42,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,223.91a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,175.42,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,216.37a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,208.82a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,201.27a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,175.42,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,193.73a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,175.42,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,186.18a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,175.42,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,178.64a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,171.09a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,175.42,171.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,163.54a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,175.42,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,156a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,175.42,156Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,257.87a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,156.56,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,250.33a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.3,
    cy: 242.78,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,235.23A1.26,1.26,0,1,1,155.3,234,1.26,1.26,0,0,1,156.56,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,227.69a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.3,
    cy: 220.14,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,212.59a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,156.56,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,205.05a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,197.5a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,156.56,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,190a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.3,
    cy: 182.41,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,174.86a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,156.56,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,167.32a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.3,
    cy: 159.77,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,152.22A1.26,1.26,0,1,1,155.3,151,1.26,1.26,0,0,1,156.56,152.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,144.68a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,144.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.3,
    cy: 137.13,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,160.33,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,160.33,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,160.33,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,160.33,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,254.1a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,160.33,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,160.33,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,231.46a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,160.33,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,160.33,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,216.37a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,208.82a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,201.27a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,160.33,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,193.73a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,160.33,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,186.18a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,160.33,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,178.64a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,171.09a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,160.33,171.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,163.54a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,160.33,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,156a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,160.33,156Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,148.45a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,160.33,148.45Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,140.9a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,160.33,140.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.33,329.56a1.23,1.23,0,0,1-1,1.21l-.89-.16a1.24,1.24,0,0,1-.6-1.05,1.26,1.26,0,1,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,164.1,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,164.1,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,164.1,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,235.23a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,227.69a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,220.14a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,164.1,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,212.59a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,205.05a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,197.5a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,190a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,182.41a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,164.1,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,174.86a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,167.32a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,159.77a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,164.1,159.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,152.22a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,164.1,152.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,144.68a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,164.1,144.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 329.56,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,322a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,167.88,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,167.88,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,167.88,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,284.28a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,167.88,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,276.74a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,167.88,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.62,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88,261.65a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,167.88,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,325.79a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,149,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,149,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,149,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,235.23a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,227.69a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,220.14a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,149,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,212.59a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,205.05a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,197.5a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,190a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,182.41a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,149,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,174.86a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,167.32a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,159.77a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,149,159.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,152.22a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,149,152.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,144.68a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,144.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,137.13a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,137.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,129.59a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,149,129.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,322a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,152.78,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,152.78,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,152.78,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,284.28a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,152.78,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,152.78,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,246.55a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,152.78,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,239a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,231.46a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,152.78,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,223.91a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,152.78,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,216.37a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,208.82a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,201.27a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,152.78,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,193.73a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,152.78,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,186.18a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,152.78,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,178.64a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,171.09a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,152.78,171.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,163.54a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,152.78,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,156a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,156Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,148.45a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,152.78,148.45Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,140.9a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,152.78,140.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,133.36a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,152.78,133.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,329.56v0l-2.43-.44a1.25,1.25,0,0,1,2.43.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,325.79a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,318.24A1.26,1.26,0,1,1,155.3,317,1.26,1.26,0,0,1,156.56,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.3,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,156.56,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,288.06a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.3,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,273a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,156.56,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,265.42a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,156.56,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,325.79a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,325.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,141.46,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,141.46,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,141.46,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,235.23a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,227.69a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,220.14a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,141.46,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,212.59a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,205.05a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,197.5a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,190a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,182.41a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,141.46,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,174.86a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,167.32a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,159.77a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,141.46,159.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,152.22a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,141.46,152.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,144.68a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,144.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,137.13a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,137.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,129.59a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,141.46,129.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,122a1.26,1.26,0,0,1-1.25,1.26,1.22,1.22,0,0,1-.74-.27l.54-1,.2-.37.43-.8A1.25,1.25,0,0,1,141.46,122Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,145.24,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,145.24,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,145.24,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,284.28A1.26,1.26,0,1,1,144,283,1.25,1.25,0,0,1,145.24,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,145.24,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,145.24,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,246.55A1.26,1.26,0,1,1,144,245.3,1.25,1.25,0,0,1,145.24,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,145.24,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,145.24,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,216.37a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,145.24,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 208.82,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,201.27A1.26,1.26,0,1,1,144,200,1.25,1.25,0,0,1,145.24,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 193.73,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,186.18a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,145.24,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,178.64a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,145.24,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 171.09,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,163.54a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,145.24,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,156a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,145.24,156Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.98,
    cy: 148.45,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,140.9a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,145.24,140.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,133.36A1.26,1.26,0,1,1,144,132.1,1.25,1.25,0,0,1,145.24,133.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,125.81a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,145.24,125.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,182.41a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,126.37,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,174.86a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,126.37,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,167.32a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,126.37,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,159.77a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,126.37,159.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,152.22a1.26,1.26,0,1,1-2.51,0,1.39,1.39,0,0,1,.09-.46l0-.09a1.25,1.25,0,0,1,2.37.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,322a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,130.15,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,130.15,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,130.15,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,284.28a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,130.15,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,276.74a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,130.15,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,261.65a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,130.15,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,246.55a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,130.15,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,239a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,130.15,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,223.91a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,130.15,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,216.37a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,130.15,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 208.82,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,201.27a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,130.15,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 193.73,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,186.18a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,130.15,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,178.64a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,130.15,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 171.09,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,163.54a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,130.15,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.15,156a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,130.15,156Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.89,
    cy: 148.45,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.06,140.46a1.33,1.33,0,0,1,.09.44,1.24,1.24,0,0,1-1,1.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,325.79a1.17,1.17,0,0,1-.08.37l-1.18-.22-.85-.15-.39-.07a1.25,1.25,0,0,1,2.5.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,318.24a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,133.92,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,133.92,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,133.92,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,235.23a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,227.69a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,220.14a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,133.92,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,212.59a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,205.05a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,197.5a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,190a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,182.41a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,133.92,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,174.86a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,167.32a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,159.77a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,133.92,159.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,152.22a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,133.92,152.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,144.68a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,133.92,144.68Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.92,137.13a1.25,1.25,0,0,1-2.37.56l.31-.56.66-1.23s.09,0,.14,0A1.26,1.26,0,0,1,133.92,137.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,137.69,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,137.69,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,137.69,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,137.69,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,254.1a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,137.69,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,137.69,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,231.46a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,137.69,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,137.69,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,216.37a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,208.82a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,201.27a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,137.69,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,193.73a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,137.69,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,186.18a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,137.69,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,178.64a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,171.09a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,137.69,171.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,163.54a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,137.69,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,156a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,156Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,148.45a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,137.69,148.45Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,140.9a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,137.69,140.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,133.36a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,137.69,133.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,318.24a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,118.83,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,118.83,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.57,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,118.83,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,288.06a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,118.83,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.57,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,273a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,118.83,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,265.42a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,118.83,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,257.87a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,118.83,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,250.33a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,118.83,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.57,
    cy: 242.78,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,235.23a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,118.83,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,227.69a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,118.83,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.57,
    cy: 220.14,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,212.59a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,118.83,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,205.05a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,118.83,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,197.5a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,118.83,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,190a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,118.83,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.57,
    cy: 182.41,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,174.86a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,118.83,174.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.83,167.32a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,118.83,167.32Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,322a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,322Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,122.6,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,122.6,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,122.6,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,284.28a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,122.6,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,254.1a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,122.6,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,122.6,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,231.46a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,122.6,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,122.6,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,216.37a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,208.82a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,201.27a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,122.6,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,193.73a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,122.6,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,186.18a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,122.6,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,178.64a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,122.6,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,171.09a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,122.6,171.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6,163.54a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,122.6,163.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.17,155.07a1.23,1.23,0,0,1,.43.93,1.25,1.25,0,0,1-1.26,1.25,1.13,1.13,0,0,1-.32-.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.12,324.53a1.16,1.16,0,0,1,.55.15l-.55-.1-.12,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,126.37,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,126.37,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,126.37,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,126.37,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,126.37,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,126.37,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,126.37,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,126.37,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,126.37,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,126.37,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,126.37,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,235.23a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,126.37,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,227.69a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,126.37,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,220.14a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,126.37,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,212.59a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,126.37,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,205.05a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,126.37,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,197.5a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,126.37,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37,190a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,126.37,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,103.73,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,103.73,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,103.73,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,103.73,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,103.73,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,103.73,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,103.73,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,103.73,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,103.73,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,103.73,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,235.23a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,103.73,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,227.69a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,103.73,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,220.14a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,103.73,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,212.59a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,103.73,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,205.05a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,103.73,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,197.5a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,103.73,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,189.42a1.23,1.23,0,0,1,.13.54,1.25,1.25,0,0,1-1.07,1.22l.66-1.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.25,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,107.51,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,107.51,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.25,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,284.28a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,107.51,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,276.74a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,107.51,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.25,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,261.65a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,107.51,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.25,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,246.55a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,107.51,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,239a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,107.51,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.25,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,223.91a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,107.51,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,216.37a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,107.51,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.25,
    cy: 208.82,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,201.27a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,107.51,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.25,
    cy: 193.73,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51,186.18a1.26,1.26,0,0,1-2.42.49L106,185a1.72,1.72,0,0,1,.24,0A1.26,1.26,0,0,1,107.51,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29,321.35l-1.78-.33a1.28,1.28,0,0,1,.74-.26A1.24,1.24,0,0,1,107.29,321.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,318.24A1.26,1.26,0,1,1,110,317,1.25,1.25,0,0,1,111.28,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,111.28,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,111.28,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,111.28,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,288.06A1.26,1.26,0,1,1,110,286.8,1.25,1.25,0,0,1,111.28,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,111.28,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,111.28,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,111.28,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,111.28,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,111.28,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,111.28,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,235.23A1.26,1.26,0,1,1,110,234,1.25,1.25,0,0,1,111.28,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,227.69a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,111.28,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,220.14a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,111.28,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,212.59a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,111.28,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,205.05a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,111.28,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,197.5a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,111.28,197.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,190A1.26,1.26,0,1,1,110,188.7,1.25,1.25,0,0,1,111.28,190Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.28,182.41a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,111.28,182.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,115.05,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,115.05,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,115.05,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,115.05,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,284.28A1.26,1.26,0,1,1,113.8,283,1.25,1.25,0,0,1,115.05,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,115.05,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,115.05,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,115.05,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,115.05,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,246.55a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,115.05,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,239a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,115.05,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,231.46a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,115.05,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,223.91a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,115.05,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,216.37a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,115.05,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,208.82a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,115.05,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,201.27A1.26,1.26,0,1,1,113.8,200,1.25,1.25,0,0,1,115.05,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,193.73a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,115.05,193.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,186.18a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,115.05,186.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,178.64a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,115.05,178.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,171.09a1.23,1.23,0,0,1-2,.95l1.15-2.14A1.24,1.24,0,0,1,115.05,171.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,322a1.27,1.27,0,0,1-.23.69l-2.22-.4a1,1,0,0,1-.06-.29,1.26,1.26,0,1,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.58,318l-1.2-.22-1-.18a1.22,1.22,0,0,1,2.22.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,88.64,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,88.64,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,88.64,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,88.64,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,280.51a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,88.64,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,88.64,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,88.64,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,88.64,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,88.64,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,242.78a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,88.64,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,235.23A1.26,1.26,0,1,1,87.38,234,1.25,1.25,0,0,1,88.64,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,227.69a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,88.64,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,220.14a1.26,1.26,0,0,1-1.26,1.26,1.28,1.28,0,0,1-.86-.35l.49-.91.37-.69.28-.51A1.23,1.23,0,0,1,88.64,220.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,314.47a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,92.41,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,92.41,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,92.41,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,92.41,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,284.28A1.26,1.26,0,1,1,91.16,283,1.25,1.25,0,0,1,92.41,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,92.41,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,92.41,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,92.41,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,254.1a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,92.41,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,246.55a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,92.41,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,239a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,92.41,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,231.46a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,92.41,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,223.91a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,92.41,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,216.37a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,92.41,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,318.24a1.24,1.24,0,0,1-.53,1l-.73-.13-1-.19a1.23,1.23,0,0,1-.23-.68,1.26,1.26,0,0,1,2.52,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,96.19,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.93,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,96.19,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,288.06a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,96.19,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.93,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,273a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,96.19,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,265.42a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,96.19,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,257.87a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,96.19,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,250.33a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,96.19,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.93,
    cy: 242.78,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,235.23A1.26,1.26,0,1,1,94.93,234,1.26,1.26,0,0,1,96.19,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,227.69a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,96.19,227.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.93,
    cy: 220.14,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,212.59a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,96.19,212.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.19,205.05a1.26,1.26,0,0,1-1.26,1.25,1.1,1.1,0,0,1-.4-.08l.4-.74.23-.43.53-1A1.25,1.25,0,0,1,96.19,205.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,314.47a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,100,314.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,100,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,100,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,100,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,284.28A1.26,1.26,0,1,1,98.7,283,1.25,1.25,0,0,1,100,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,100,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,100,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,100,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,254.1a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,100,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,100,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,239a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,100,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,231.46a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,100,231.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,223.91a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,100,223.91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,216.37a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,100,216.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,208.82a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,100,208.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,201.27A1.26,1.26,0,1,1,98.7,200,1.25,1.25,0,0,1,100,201.27Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,318.24a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,103.73,318.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46,310.7a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,58.46,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.2,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46,295.6a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,58.46,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.46,288.06a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,58.46,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.2,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,306.92A1.26,1.26,0,1,1,61,305.67,1.25,1.25,0,0,1,62.23,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,299.38A1.26,1.26,0,1,1,61,298.12,1.25,1.25,0,0,1,62.23,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,291.83A1.26,1.26,0,1,1,61,290.57,1.26,1.26,0,0,1,62.23,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,284.28A1.26,1.26,0,1,1,61,283,1.25,1.25,0,0,1,62.23,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,276.74A1.26,1.26,0,1,1,61,275.48,1.25,1.25,0,0,1,62.23,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,269.19a1.25,1.25,0,0,1-2.18.84L61.17,268A1.25,1.25,0,0,1,62.23,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,66,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,66,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,66,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,66,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,66,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,66,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,66,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,69.77,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,69.77,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,69.77,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,284.28A1.26,1.26,0,1,1,68.52,283,1.25,1.25,0,0,1,69.77,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,276.74a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,69.77,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,269.19a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,69.77,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,261.65a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,69.77,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,254.1A1.24,1.24,0,0,1,68,255.26l1.17-2.18A1.24,1.24,0,0,1,69.77,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,314.47s0,0,0,.08l-2.43-.44a1.24,1.24,0,0,1,2.44.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,310.7a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,73.55,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.29,
    cy: 303.15,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,73.55,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,288.06a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,73.55,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.29,
    cy: 280.51,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,273a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,73.55,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,265.42a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,73.55,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,257.87a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,73.55,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,250.33a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,73.55,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,306.92a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,77.32,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,299.38a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,77.32,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,291.83a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,77.32,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,284.28A1.26,1.26,0,1,1,76.06,283,1.25,1.25,0,0,1,77.32,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,276.74a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,77.32,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,269.19a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,77.32,269.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,261.65a1.26,1.26,0,1,1-1.26-1.26A1.25,1.25,0,0,1,77.32,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,254.1a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,77.32,254.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,246.55a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,77.32,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.32,314.47a1.25,1.25,0,0,1-1.16,1.24l-.63-.12a1.23,1.23,0,0,1-.72-1.12,1.26,1.26,0,1,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.14,238.4a1.15,1.15,0,0,1,.18.61,1.25,1.25,0,0,1-1.17,1.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,310.7a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,81.09,310.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,303.15a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,81.09,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,295.6a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,81.09,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,288.06a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,81.09,288.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,280.51a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,81.09,280.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,273a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,81.09,273Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,265.42a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,81.09,265.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,257.87a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,81.09,257.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,250.33a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,81.09,250.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,242.78a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,81.09,242.78Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.09,235.23a1.25,1.25,0,0,1-1.25,1.26,1.24,1.24,0,0,1-1.18-.89l.19-.37.65-1.18a1,1,0,0,1,.34-.07A1.25,1.25,0,0,1,81.09,235.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.61,
    cy: 314.47,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,84.87,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,84.87,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.61,
    cy: 291.83,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,284.28A1.26,1.26,0,1,1,83.61,283,1.26,1.26,0,0,1,84.87,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,276.74a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,84.87,276.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.61,
    cy: 269.19,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,261.65a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,84.87,261.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.61,
    cy: 254.1,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,246.55a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,84.87,246.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.87,239a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,84.87,239Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.61,
    cy: 231.46,
    r: 1.26,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.81,224.22a1.24,1.24,0,0,1-.33.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.68,284.28a1.24,1.24,0,0,1-2.46.25l.76-1.41a1.13,1.13,0,0,1,.45-.09A1.25,1.25,0,0,1,54.68,284.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.68,287.38a1.23,1.23,0,0,1,.23.68,1.25,1.25,0,0,1-1.26,1.25h0v0l.67-1.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.91,295.6a1.26,1.26,0,1,1-1.26-1.25A1.25,1.25,0,0,1,50.91,295.6Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.91,310.7a1.17,1.17,0,0,1-.09.42l-1.17-.21-1.16-.21-.09,0a1.26,1.26,0,0,1,2.51,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.91,303.15a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,50.91,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.68,306.92a1.26,1.26,0,1,1-1.25-1.25A1.25,1.25,0,0,1,54.68,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.68,299.38a1.26,1.26,0,1,1-1.25-1.26A1.25,1.25,0,0,1,54.68,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.68,291.83a1.26,1.26,0,1,1-1.25-1.26A1.26,1.26,0,0,1,54.68,291.83Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.14,299.38a1.26,1.26,0,1,1-1.26-1.26A1.26,1.26,0,0,1,47.14,299.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.14,306.92a1.26,1.26,0,1,1-1.26-1.25A1.26,1.26,0,0,1,47.14,306.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.36,303.15a1.26,1.26,0,0,1-1.25,1.26,1.28,1.28,0,0,1-.55-.14l.55-1,0-.1.58-1.06A1.24,1.24,0,0,1,43.36,303.15Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.11,309.44a1.22,1.22,0,0,1,.67.22l-.67-.12-.26-.05A1,1,0,0,1,42.11,309.44Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93,274l.52-.95A1.26,1.26,0,0,1,57.93,274Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,162.84a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,444.18,162.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,155.65a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,444.18,155.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,148.47a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,444.18,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,141.28a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,444.18,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.98,
    cy: 134.1,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,444.18,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,119.73a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,444.18,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 442.98,
    cy: 112.55,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,444.18,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,98.18A1.2,1.2,0,1,1,443,97,1.2,1.2,0,0,1,444.18,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,444.18,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.57,150.86l.09,0-.43,2.31a1.19,1.19,0,0,1-.86-1.13A1.2,1.2,0,0,1,446.57,150.86Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,144.88a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,447.77,144.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,137.69a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,447.77,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.57,
    cy: 130.51,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,447.77,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,116.14a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,447.77,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,447.77,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,101.77a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,447.77,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.57,
    cy: 94.59,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.77,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,447.77,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,132.94l-.22,1.16-.19,1a1.2,1.2,0,0,1-.63-1A1.17,1.17,0,0,1,450,132.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,84l1.15,0,1.15,0a1.19,1.19,0,0,1-1.15.93A1.17,1.17,0,0,1,449,84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.23,126.4l-.1.52-.16.87a1.16,1.16,0,0,1-.81.32,1.2,1.2,0,0,1,0-2.39A1.2,1.2,0,0,1,451.23,126.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.36,119.73a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.36,112.55a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,451.36,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.36,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,451.36,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.36,98.18a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.36,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,451.36,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.35,115l-.37,2a1.15,1.15,0,0,1-.42-.89A1.17,1.17,0,0,1,453.35,115Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,101.77a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,455,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,94.59a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,455,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,455,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.75,107.76a1.18,1.18,0,0,1,.88.4l-.35,1.86a1.15,1.15,0,0,1-.53.13,1.2,1.2,0,0,1,0-2.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.67,97.22l-.18,1-.12.65a1.13,1.13,0,0,1-.22-.65A1.18,1.18,0,0,1,456.67,97.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.35,89.8A1.17,1.17,0,0,1,458,90l-.18,1-.21,1.14a1.28,1.28,0,0,1-.27,0,1.2,1.2,0,1,1,0-2.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.44,84.29a1.18,1.18,0,0,1-1.09.72,1.2,1.2,0,0,1-1.12-.78l1.12,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,198.76a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,429.81,198.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,191.57a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,184.39a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,429.81,184.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,177.2a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,170a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,429.81,170Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,162.84a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,429.81,162.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,155.65a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,148.47a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,429.81,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,141.28a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,429.81,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,134.1a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,429.81,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,429.81,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,119.73a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,112.55a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,429.81,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,429.81,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,98.18a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,429.81,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.73,83.42a1.23,1.23,0,0,1,.08.39,1.2,1.2,0,1,1-2.39,0,1.18,1.18,0,0,1,.09-.46l1.1,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,209.53a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,433.4,209.53Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,202.35a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.4,202.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,195.16a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,188a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,433.4,188Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,180.8a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.4,180.8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,173.61a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,166.43a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.4,166.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,159.24a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,152.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,433.4,152.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,144.88a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.4,144.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,137.69a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,130.51a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,433.4,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.4,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,116.14a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.4,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,101.77a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,94.59a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,433.4,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.4,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,433.4,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.24,212.08l-.19,1-.15.78a1.2,1.2,0,0,1-.3-.78A1.19,1.19,0,0,1,435.24,212.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.8,204.74a1.17,1.17,0,0,1,.76.3l-.17.9-.21,1.12a1.23,1.23,0,0,1-.38.08,1.2,1.2,0,0,1,0-2.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,198.76a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,198.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,191.57a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,437,191.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,184.39a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,184.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,177.2A1.2,1.2,0,1,1,435.8,176,1.19,1.19,0,0,1,437,177.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,170a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,170Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,162.84a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,162.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,155.65a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,437,155.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,148.47a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,141.28a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,437,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,134.1a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,126.92a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,119.73a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,437,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,112.55a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,105.37a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,98.18A1.2,1.2,0,1,1,435.8,97,1.19,1.19,0,0,1,437,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,91a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,437,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,83.64a1,1,0,0,1,0,.17,1.2,1.2,0,1,1-2.39,0,1,1,0,0,1,0-.24l1.15,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.19,195.16a1.16,1.16,0,0,1,.37-.85l-.25,1.35A1.19,1.19,0,0,1,438.19,195.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,180.8a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,173.61a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,440.58,173.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,166.43a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,159.24a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,440.58,159.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,152.06a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,440.58,152.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,144.88a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,137.69a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,440.58,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,130.51a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,440.58,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,123.33a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,440.58,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,116.14a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,440.58,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,109a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,101.77a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,440.58,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,94.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,440.58,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.58,87.41a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.39,186.78a1.21,1.21,0,0,1,.54.15l-.41,2.22-.13,0a1.2,1.2,0,1,1,0-2.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.78,83.81s0,0,0,0l1,0H443l1.19,0a1.2,1.2,0,0,1-2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,168.82a1.14,1.14,0,0,1,.32.07l-.21,1.13-.11.59-.11.58a1.18,1.18,0,0,1-1.09-1.17A1.2,1.2,0,0,1,443,168.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,191.57a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,184.39a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.44,184.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,177.2a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,170a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,415.44,170Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,162.84a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.44,162.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,155.65a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,148.47a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.44,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,141.28a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,415.44,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,134.1a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,415.44,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.44,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,119.73a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,112.55a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,415.44,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.44,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,98.18a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,415.44,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.09,83a1.15,1.15,0,0,1,.35.84,1.2,1.2,0,1,1-2.39,0,1.18,1.18,0,0,1,.42-.89l.77,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,195.16a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,419,195.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,188a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,419,188Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,180.8a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,173.61a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,419,173.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,166.43a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,159.24a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,419,159.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,152.06a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,419,152.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,144.88a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,137.69a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,419,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,130.51a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,419,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,123.33a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,419,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,116.14a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,419,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,109a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,101.77a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,419,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,94.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,419,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,87.41a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,198.76a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,422.62,198.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,191.57a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,422.62,191.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,184.39a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,177.2a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,422.62,177.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,170a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,422.62,170Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,162.84a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,155.65a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,422.62,155.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,148.47a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,141.28a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,422.62,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,134.1a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,422.62,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,126.92a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,119.73a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,422.62,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,112.55a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,422.62,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,105.37a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,98.18A1.2,1.2,0,1,1,421.43,97,1.19,1.19,0,0,1,422.62,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.62,91a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.42,83.19a1.14,1.14,0,0,1,.2.62,1.2,1.2,0,1,1-2.15-.68l1,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,202.35a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,426.22,202.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,195.16A1.2,1.2,0,1,1,425,194,1.2,1.2,0,0,1,426.22,195.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.02,
    cy: 187.98,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,180.8a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,426.22,180.8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,173.61a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,426.22,173.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,166.43a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,426.22,166.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,159.24a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,426.22,159.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.02,
    cy: 152.06,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,144.88a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,426.22,144.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,137.69a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,426.22,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.02,
    cy: 130.51,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,426.22,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,116.14A1.2,1.2,0,1,1,425,115,1.2,1.2,0,0,1,426.22,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,426.22,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,101.77a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,426.22,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.02,
    cy: 94.59,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,426.22,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.81,205.94a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,429.81,205.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,177.2a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,401.07,177.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,170a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,401.07,170Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,162.84a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,155.65a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,401.07,155.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,148.47a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,141.28a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,401.07,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,134.1a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,401.07,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,126.92a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,119.73a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,401.07,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,112.55a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,401.07,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,105.37a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,98.18A1.2,1.2,0,1,1,399.88,97,1.19,1.19,0,0,1,401.07,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,91a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,83.81a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,401.07,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,180.8a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,173.61a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,404.66,173.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,166.43a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,159.24a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,404.66,159.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,152.06a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,404.66,152.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,144.88a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,137.69a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,404.66,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,130.51a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,404.66,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,123.33a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,404.66,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,116.14a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,404.66,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,109a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,101.77a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,404.66,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,94.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,404.66,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.66,87.41a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,184.39a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,408.26,184.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,177.2a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,408.26,177.2Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.06,
    cy: 170.02,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,162.84a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,408.26,162.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,155.65a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,408.26,155.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,148.47a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,408.26,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,141.28a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,408.26,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.06,
    cy: 134.1,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,408.26,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,119.73a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,408.26,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.06,
    cy: 112.55,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,408.26,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,98.18a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,408.26,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,408.26,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,83.81a1.2,1.2,0,1,1-1.64-1.1h.44l.5,0A1.18,1.18,0,0,1,408.26,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,188a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,411.85,188Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,180.8a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,411.85,180.8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,173.61a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,166.43a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,411.85,166.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,159.24a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,152.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,411.85,152.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,144.88a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,411.85,144.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,137.69a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,130.51a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,411.85,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,411.85,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,116.14a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,411.85,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,101.77a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,94.59a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,411.85,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,411.85,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,155.65a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,379.52,155.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,148.47a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,379.52,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,141.28a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,379.52,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,134.1a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,379.52,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,126.92a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,379.52,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,119.73a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,379.52,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,112.55a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,379.52,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,105.37a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,379.52,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,98.18A1.2,1.2,0,1,1,378.33,97,1.19,1.19,0,0,1,379.52,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,91a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,379.52,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,83.81a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,379.52,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,159.24a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,383.11,159.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,152.06a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,383.11,152.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,144.88a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,137.69a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,383.11,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,130.51a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,383.11,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,123.33a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,383.11,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,116.14a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,383.11,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,109a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,101.77a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,383.11,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,94.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,383.11,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,87.41a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,162.84a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,386.71,162.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,155.65a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,386.71,155.65Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,148.47a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,386.71,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,141.28a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,386.71,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.51,
    cy: 134.1,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,386.71,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,119.73a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,386.71,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.51,
    cy: 112.55,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,386.71,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,98.18a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,386.71,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,386.71,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.71,83.81a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,386.71,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,166.43a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,390.3,166.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,159.24a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,390.3,159.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.1,
    cy: 152.06,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,144.88a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,390.3,144.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,137.69a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,390.3,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.1,
    cy: 130.51,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,390.3,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,116.14a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,390.3,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,390.3,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,101.77a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,390.3,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.1,
    cy: 94.59,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,390.3,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,170a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,393.89,170Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,162.84a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,393.89,162.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,155.65a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,148.47a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,393.89,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,141.28a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,393.89,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,134.1a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,393.89,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,393.89,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,119.73a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,112.55a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,393.89,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,393.89,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,98.18a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,393.89,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.89,83.81a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,393.89,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,173.61a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,397.48,173.61Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,166.43a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,397.48,166.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,159.24a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,397.48,159.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,152.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,397.48,152.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,144.88a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,397.48,144.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,137.69a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,397.48,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,130.51a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,397.48,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,397.48,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,116.14a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,397.48,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,397.48,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,101.77a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,397.48,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,94.59a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,397.48,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.48,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,397.48,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,350.79,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,98.18a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,350.79,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,350.79,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,83.81a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,350.79,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,130.51a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,354.38,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,354.38,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,116.14a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,354.38,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,101.77a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,94.59a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,354.38,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,354.38,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.18,81.42a1.22,1.22,0,0,1-.86-.37l1.67,0A1.24,1.24,0,0,1,353.18,81.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,134.1a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,358,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,358,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,119.73a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,112.55a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,358,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,358,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,98.18a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,358,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,83.81a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,358,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,137.69a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,361.56,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,130.51a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,361.56,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,123.33a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,361.56,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,116.14a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,361.56,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,109a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,361.56,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,101.77a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,361.56,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,94.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,361.56,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,87.41a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,361.56,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.37,81.42a1.09,1.09,0,0,1-.54-.15l1,0A1.17,1.17,0,0,1,360.37,81.42Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,141.28a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,365.15,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,134.1a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,365.15,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,126.92a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,119.73a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,365.15,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,112.55a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,365.15,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,105.37a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,98.18A1.2,1.2,0,1,1,364,97,1.19,1.19,0,0,1,365.15,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,91a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,83.81A1.2,1.2,0,1,1,364,82.62,1.19,1.19,0,0,1,365.15,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,144.88a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,368.75,144.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,137.69a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,368.75,137.69Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.55,
    cy: 130.51,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,368.75,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,116.14a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,368.75,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,368.75,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,101.77a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,368.75,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.55,
    cy: 94.59,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,368.75,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,148.47a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,372.34,148.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,141.28a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,372.34,141.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,134.1a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,372.34,134.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,372.34,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,119.73a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,112.55a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,372.34,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,372.34,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,98.18a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,372.34,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,83.81a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,372.34,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,152.06a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,375.93,152.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,144.88a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,375.93,144.88Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,137.69a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,130.51a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,375.93,130.51Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,123.33a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,375.93,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,116.14a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,375.93,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,101.77a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,94.59a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,375.93,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,375.93,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.87,79.56a1.16,1.16,0,0,1,.22.66,1.2,1.2,0,1,1-2.39,0,1.24,1.24,0,0,1,.26-.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.19,79.79a1.22,1.22,0,0,1,.09.43,1.2,1.2,0,1,1-2.4,0,1.19,1.19,0,0,1,.12-.5Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.28,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,311.28,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.68,83.81a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,307.68,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.87,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,314.87,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.87,83.81a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,314.87,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.46,94.59a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,318.46,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.46,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,318.46,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.42,80a1.55,1.55,0,0,1,0,.21,1.2,1.2,0,1,1-2.39,0,1.26,1.26,0,0,1,.05-.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.05,98.18a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,322.05,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.05,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,322.05,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.05,83.81a1.2,1.2,0,1,1-1.2-1.19A1.19,1.19,0,0,1,322.05,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.64,101.77a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,325.64,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.64,94.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,325.64,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.64,87.41a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.26,80.16l2.38.07a1.19,1.19,0,0,1-1.19,1.19,1.2,1.2,0,0,1-1.2-1.2S323.26,80.18,323.26,80.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.23,105.37a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.23,98.18A1.2,1.2,0,1,1,328,97,1.19,1.19,0,0,1,329.23,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.23,91a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.23,83.81A1.2,1.2,0,1,1,328,82.62,1.19,1.19,0,0,1,329.23,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,332.83,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,101.77a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,332.83,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.63,
    cy: 94.59,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.83,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,332.83,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.47,80.38l2.31.07a1.17,1.17,0,0,1-2.31-.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.42,112.55a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,336.42,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.42,105.37a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,336.42,105.37Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.42,98.18a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.42,91a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,336.42,91Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.42,83.81a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,336.42,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,116.14a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,109a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,340,109Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,101.77a1.2,1.2,0,1,1-2.39,0,1.2,1.2,0,0,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,94.59a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,340,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,87.41a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,340,87.41Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.69,80.6l2.23.07a1.19,1.19,0,0,1-2.23-.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,119.73a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,343.6,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,112.55a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,343.6,112.55Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,105.37a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,98.18A1.2,1.2,0,1,1,342.41,97,1.19,1.19,0,0,1,343.6,98.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,91a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.6,83.81a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,343.6,83.81Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.19,123.33a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,347.19,123.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.19,116.14A1.2,1.2,0,1,1,346,115,1.19,1.19,0,0,1,347.19,116.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.19,109a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.19,101.77a1.2,1.2,0,1,1-1.19-1.19A1.19,1.19,0,0,1,347.19,101.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.19,94.59a1.2,1.2,0,1,1-1.19-1.2A1.19,1.19,0,0,1,347.19,94.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.19,87.41a1.2,1.2,0,0,1-2.39,0,1.2,1.2,0,1,1,2.39,0Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,80.82l2,.06a1.17,1.17,0,0,1-1,.54A1.19,1.19,0,0,1,345,80.82Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,126.92a1.2,1.2,0,1,1-1.2-1.2A1.19,1.19,0,0,1,350.79,126.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,119.73a1.2,1.2,0,1,1-1.2-1.19A1.2,1.2,0,0,1,350.79,119.73Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.59,
    cy: 112.55,
    r: 1.2,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.31,439.23c0,11.28-88.78,20.42-198.31,20.42S51.69,450.51,51.69,439.23,140.47,418.81,250,418.81,448.31,428,448.31,439.23Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-30"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.98 406.44 97.74 406.2 148.49 406.11 250 405.95 351.51 406.11 402.26 406.2 453.01 406.44 402.26 406.69 351.51 406.78 250 406.94 148.49 406.78 97.74 406.69 46.98 406.44",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.52,61.92H165.46a17.26,17.26,0,0,0-17.1,17.42v348a17.27,17.27,0,0,0,17.1,17.42H334.52a17.29,17.29,0,0,0,17.12-17.42v-348A17.28,17.28,0,0,0,334.52,61.92Zm6.42,354.67c0,9.16-6.86,16.57-15.32,16.57H174.38c-8.48,0-15.34-7.41-15.34-16.57V92.53C159,73.87,165.9,73,174.38,73h30.3c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83H285c3.94,0,7.1,0,7.1-5.83V77.44c0-2.48,1.42-4.48,3.21-4.48h30.29c8.46,0,15.32,2.48,15.32,19.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.94,92.53V416.59c0,9.16-6.86,16.57-15.32,16.57H174.38c-8.48,0-15.34-7.41-15.34-16.57V92.53C159,73.87,165.9,73,174.38,73h30.3c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83H285c3.94,0,7.1,0,7.1-5.83V77.44c0-2.48,1.42-4.48,3.21-4.48h30.29C334.08,73,340.94,75.44,340.94,92.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.94,92.53V228.75H159V92.53C159,73.87,165.9,73,174.38,73h30.3c1.76,0,3.2,2,3.2,4.48v1.07c0,5.81,3.18,5.83,7.08,5.83H285c3.94,0,7.1,0,7.1-5.83V77.44c0-2.48,1.42-4.48,3.21-4.48h30.29C334.08,73,340.94,75.44,340.94,92.53Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.45,80.24l-.29.29c-.06,0-.11.11-.17.17a3.9,3.9,0,0,0-2.82-1.17,3.86,3.86,0,0,0-2.82,1.17l-.16-.17-.29-.29h0l0,0,.37-.32a4.06,4.06,0,0,1,.86-.55,4.18,4.18,0,0,1,1.13-.38c.19,0,.38,0,.57-.08h.5l.38,0a4.51,4.51,0,0,1,1,.25,4.58,4.58,0,0,1,.71.33,4.48,4.48,0,0,1,.67.47l.31.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,81.62c-.15-.16-.3-.31-.46-.46a3.32,3.32,0,0,1,4.71,0l-.46.46a2.68,2.68,0,0,0-3.79,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,82.08l-.46.46a1.31,1.31,0,0,0-1-.4,1.35,1.35,0,0,0-1,.4l-.46-.46A2,2,0,0,1,197.6,82.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.58,83a.41.41,0,0,1-.41.41.42.42,0,1,1,0-.83A.41.41,0,0,1,196.58,83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,81.12a1.21,1.21,0,1,1,1.21,1.21A1.21,1.21,0,0,1,170.9,81.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.7,81.12a1.21,1.21,0,1,1,1.21,1.21A1.21,1.21,0,0,1,174.7,81.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,81.12a1.21,1.21,0,1,1,1.2,1.21A1.2,1.2,0,0,1,178.5,81.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.3,81.12a1.21,1.21,0,1,1,1.2,1.21A1.2,1.2,0,0,1,182.3,81.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.09,81.12a1.21,1.21,0,1,1,1.21,1.21A1.21,1.21,0,0,1,186.09,81.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.3,83.75h-9.82V79.21h9.82Zm-9.32-.5h8.82V79.71H318Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 79.98,
    width: 6.33,
    height: 3,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.3,
    y: 80.27,
    width: 0.87,
    height: 2.43,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.28 110.7 170.91 105.67 176.28 100.64 177.11 101.52 172.69 105.67 177.11 109.82 176.28 110.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,190.94a39.29,39.29,0,0,1-11.55,4.84A40.08,40.08,0,1,1,271,190.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.17,152.29A12.19,12.19,0,1,1,250,140.1,12.19,12.19,0,0,1,262.17,152.29Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,185.92v5a39.29,39.29,0,0,1-11.55,4.84,39.88,39.88,0,0,1-30.57-4.85v-5a21.06,21.06,0,1,1,42.12,0Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.52,
    y: 214.87,
    width: 142.96,
    height: 138.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.78,231.38l-3.67,8.74a.47.47,0,0,1-.08.14h0l-.08.09s0,0,0,0a.34.34,0,0,0-.11.07h0c-.05,0-.08.08-.14.09h0a0,0,0,0,0,0,0l-.12,0h-.36l-.1,0,0,0a.28.28,0,0,1-.14-.09h0l-.11-.07,0,0a.47.47,0,0,0-.06-.09s0,0,0,0a.45.45,0,0,1-.06-.14l-2-4.65-2,4.65a.45.45,0,0,1-.06.14,0,0,0,0,0,0,0l-.09.09s0,0,0,0a.18.18,0,0,0-.08.07h0a.74.74,0,0,1-.12.09h0a0,0,0,0,0,0,0,.21.21,0,0,0-.12,0h-.37a.26.26,0,0,0-.11,0l0,0a.34.34,0,0,1-.14-.09h0c-.05,0-.06-.06-.11-.07a.09.09,0,0,1,0,0l-.08-.09h0s0-.09-.07-.14l-3.69-8.74a.82.82,0,0,1,1.52-.63l2.93,6.94,1.94-4.6a.82.82,0,0,1,.78-.51.86.86,0,0,1,.78.51l1.93,4.6,2.93-6.94a.83.83,0,0,1,1.09-.44A.81.81,0,0,1,226.78,231.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.19,239.81V231a.81.81,0,0,1,.82-.83h4.9a.83.83,0,0,1,.83.83.85.85,0,0,1-.83.84h-4.06v2.74h3.49a.84.84,0,0,1,0,1.67h-3.49V239h4.06a.83.83,0,1,1,0,1.66H230A.81.81,0,0,1,229.19,239.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.08,239.81V231a.83.83,0,0,1,.82-.83.85.85,0,0,1,.85.83v8h4.06a.83.83,0,0,1,0,1.66H238.9A.82.82,0,0,1,238.08,239.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46,235.23a5.5,5.5,0,0,1,5.5-5.4,5.67,5.67,0,0,1,3.47,1.17.89.89,0,0,1,.15,1.2.88.88,0,0,1-1.2.17,3.76,3.76,0,0,0-2.42-.83,4,4,0,0,0-2.7,1.08,3.72,3.72,0,0,0-1.09,2.61,3.66,3.66,0,0,0,1.09,2.61,4,4,0,0,0,2.7,1.08,3.79,3.79,0,0,0,2.42-.82.9.9,0,0,1,1.2.16.88.88,0,0,1-.15,1.2,5.61,5.61,0,0,1-3.47,1.17A5.48,5.48,0,0,1,245.46,235.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.47,231.44a5.52,5.52,0,0,1,0,7.59,5,5,0,0,1-3.59,1.6,5.06,5.06,0,0,1-3.67-1.6,5.58,5.58,0,0,1,0-7.59,5,5,0,0,1,3.67-1.61A4.88,4.88,0,0,1,265.47,231.44Zm-.2,3.79a3.85,3.85,0,0,0-1-2.62,3.23,3.23,0,0,0-4.8,0,3.8,3.8,0,0,0-1,2.62,3.74,3.74,0,0,0,1,2.61,3.21,3.21,0,0,0,4.8,0A3.79,3.79,0,0,0,265.27,235.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.37,231v8.85a.84.84,0,0,1-.84.82.82.82,0,0,1-.83-.82v-6.32l-2.16,3a.8.8,0,0,1-.67.35h0a.83.83,0,0,1-.69-.35l-2.15-3v6.32a.83.83,0,0,1-1.66,0V231a.83.83,0,0,1,.82-.83h0a.8.8,0,0,1,.66.35l3,4.14,3-4.14a.8.8,0,0,1,.67-.35h0A.86.86,0,0,1,278.37,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.25,239.81V231a.81.81,0,0,1,.82-.83H287a.83.83,0,0,1,.82.83.85.85,0,0,1-.82.84h-4.07v2.74h3.5a.84.84,0,0,1,0,1.67h-3.5V239H287a.83.83,0,0,1,0,1.66h-4.91A.82.82,0,0,1,281.25,239.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.24,265.24V261.7a.33.33,0,0,1,.33-.33h2a.34.34,0,0,1,0,.67h-1.62v1.1h1.39a.33.33,0,0,1,0,.66h-1.39v1.11h1.62a.33.33,0,0,1,0,.66h-2A.33.33,0,0,1,195.24,265.24Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.41,261.7v3.54a.34.34,0,0,1-.34.33.33.33,0,0,1-.33-.33v-2.52l-.86,1.2a.32.32,0,0,1-.27.13h0a.34.34,0,0,1-.28-.13l-.85-1.2v2.52a.34.34,0,0,1-.67,0V261.7a.33.33,0,0,1,.33-.33h0a.33.33,0,0,1,.26.14l1.19,1.66,1.2-1.66a.32.32,0,0,1,.27-.14h0A.35.35,0,0,1,202.41,261.7Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.61,264.58h-1.45l-.3.78a.34.34,0,0,1-.31.21.2.2,0,0,1-.11,0,.33.33,0,0,1-.2-.43l1.32-3.53a.34.34,0,0,1,.32-.21.32.32,0,0,1,.32.21l1.33,3.53a.34.34,0,0,1-.2.43.22.22,0,0,1-.12,0,.32.32,0,0,1-.3-.21Zm-.24-.66-.49-1.29-.48,1.29Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.39,261.7a.33.33,0,0,1,.33-.33.34.34,0,0,1,.34.33v3.54a.34.34,0,0,1-.34.33.33.33,0,0,1-.33-.33Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.18,265.24V261.7a.33.33,0,0,1,.33-.33.34.34,0,0,1,.34.33v3.21h1.62a.33.33,0,0,1,0,.66h-2A.33.33,0,0,1,209.18,265.24Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,276.91a1.42,1.42,0,1,1,2.84-.11h0a.15.15,0,0,1-.15.14h-2.41a1.15,1.15,0,0,0,1.14,1.12,1.11,1.11,0,0,0,1-.53.15.15,0,0,1,.19-.05.16.16,0,0,1,.05.21,1.4,1.4,0,0,1-1.19.66A1.44,1.44,0,0,1,195,276.91Zm.3-.24h2.23a1.13,1.13,0,0,0-2.23,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,276.63a.91.91,0,1,0-1.81,0v1.62h0v0a.12.12,0,0,1-.07.07.11.11,0,0,1-.07,0h0l0,0h0l0,0h0v0h0v0h0v-1.62a.91.91,0,1,0-1.81,0v1.6a.14.14,0,0,1-.06.12l0,0H199a.15.15,0,0,1-.12-.11v-2.68a.14.14,0,0,1,.14-.14.14.14,0,0,1,.14.14v.28a1.18,1.18,0,0,1,.91-.42,1.21,1.21,0,0,1,1,.62,1.21,1.21,0,0,1,1.05-.62,1.19,1.19,0,0,1,1.2,1.19v1.6a.14.14,0,0,1-.15.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.74,276.63a.91.91,0,1,0-1.82,0v1.62h0v0a.18.18,0,0,1-.08.07.08.08,0,0,1-.07,0h0l0,0h0l0,0h0v0h0v0h0v-1.62a.91.91,0,1,0-1.81,0v1.6a.15.15,0,0,1-.07.12l0,0h-.06a.13.13,0,0,1-.12-.11v-2.68a.13.13,0,0,1,.13-.14.14.14,0,0,1,.15.14v.28a1.16,1.16,0,0,1,.9-.42,1.18,1.18,0,0,1,1.05.62,1.22,1.22,0,0,1,1.06-.62,1.19,1.19,0,0,1,1.19,1.19v1.6a.14.14,0,0,1-.28,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.71,275.58v2.65a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14v-.44a1.35,1.35,0,0,1-1.1.58,1.47,1.47,0,0,1,0-2.94,1.35,1.35,0,0,1,1.1.58v-.43a.14.14,0,0,1,.14-.15A.15.15,0,0,1,212.71,275.58Zm-.29,1.32a1.11,1.11,0,1,0-1.1,1.18A1.15,1.15,0,0,0,212.42,276.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.23,279.23a.22.22,0,0,0,.22-.22v-3.43a.15.15,0,0,1,.15-.15.15.15,0,0,1,.14.15V279a.51.51,0,0,1-.51.51.14.14,0,0,1-.14-.14A.14.14,0,0,1,214.23,279.23Zm.23-4.61a.16.16,0,0,1,.15-.15.15.15,0,0,1,.14.15v.14a.15.15,0,0,1-.14.15.17.17,0,0,1-.15-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.51,275.58v2.65a.14.14,0,0,1-.28,0v-.44a1.39,1.39,0,0,1-1.11.58,1.47,1.47,0,0,1,0-2.94,1.39,1.39,0,0,1,1.11.58v-.43a.14.14,0,1,1,.28,0Zm-.28,1.32a1.11,1.11,0,1,0-1.11,1.18A1.15,1.15,0,0,0,218.23,276.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,276.63a.91.91,0,1,0-1.82,0v1.62h0v0a.12.12,0,0,1-.07.07.1.1,0,0,1-.07,0h0l0,0h0v0h0v0h0v0h0v-1.62a.91.91,0,1,0-1.81,0v1.6a.15.15,0,0,1-.07.12l0,0h-.06a.15.15,0,0,1-.12-.11v-2.68a.14.14,0,0,1,.14-.14.14.14,0,0,1,.15.14v.28a1.16,1.16,0,0,1,.9-.42,1.18,1.18,0,0,1,1.05.62,1.22,1.22,0,0,1,1.06-.62,1.19,1.19,0,0,1,1.19,1.19v1.6a.14.14,0,0,1-.28,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.26,276.91a1.42,1.42,0,1,1,2.84-.11h0a.14.14,0,0,1-.14.14h-2.41a1.15,1.15,0,0,0,1.14,1.12,1.08,1.08,0,0,0,.94-.53.16.16,0,0,1,.2-.05.16.16,0,0,1,0,.21,1.39,1.39,0,0,1-1.18.66A1.45,1.45,0,0,1,225.26,276.91Zm.31-.24h2.22a1.13,1.13,0,0,0-1.1-.95A1.15,1.15,0,0,0,225.57,276.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.92,277.76a.14.14,0,0,1,.2,0,1.6,1.6,0,0,0,.9.34.87.87,0,0,0,.56-.18.43.43,0,0,0,.22-.36.46.46,0,0,0-.21-.36A1.52,1.52,0,0,0,230,277h0a1.56,1.56,0,0,1-.67-.23.62.62,0,0,1-.32-.52.75.75,0,0,1,.32-.58,1.26,1.26,0,0,1,.72-.2,1.62,1.62,0,0,1,.88.32.17.17,0,0,1,0,.21.15.15,0,0,1-.2,0,1.26,1.26,0,0,0-.72-.3.91.91,0,0,0-.56.17.45.45,0,0,0-.18.34.35.35,0,0,0,.16.29,1.66,1.66,0,0,0,.6.21h0a2,2,0,0,1,.71.23.7.7,0,0,1,0,1.2,1.18,1.18,0,0,1-.73.23,1.75,1.75,0,0,1-1.08-.42A.13.13,0,0,1,228.92,277.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.25,277.51H232l-.09,0a.16.16,0,0,1,0-.21l2.43-3h0a.13.13,0,0,1,.2,0,.15.15,0,0,1,0,.07v2.92h.28a.15.15,0,1,1,0,.29h-.28v.72a.15.15,0,0,1-.3,0Zm0-.29v-2.46l-2,2.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.92,274.17a2.09,2.09,0,0,1,2.1,2.1,2.05,2.05,0,0,1-.22,1,1.06,1.06,0,0,1-.54.45h-.12a.42.42,0,0,1-.35-.16.5.5,0,0,1-.09-.29V277a1,1,0,0,1-.78.36,1.13,1.13,0,0,1,0-2.25,1.1,1.1,0,0,1,1.07,1.12v1h0a.38.38,0,0,0,0,.13.14.14,0,0,0,.11,0h0a.61.61,0,0,0,.35-.31,1.72,1.72,0,0,0,.2-.82,1.81,1.81,0,1,0-1.81,1.81,1.68,1.68,0,0,0,.45-.05c.08,0,.17,0,.17.1a.14.14,0,0,1-.1.18,2.18,2.18,0,0,1-.52.06,2.1,2.1,0,1,1,0-4.2Zm0,2.92a.8.8,0,0,0,.77-.82.77.77,0,1,0-1.53,0A.79.79,0,0,0,237.92,277.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.14,276.63a.91.91,0,1,0-1.81,0v1.62h0v0a.12.12,0,0,1-.07.07.11.11,0,0,1-.07,0h-.05l0,0h0l0,0h0v0h0v0h0v-1.62a.91.91,0,1,0-1.81,0v1.6a.14.14,0,0,1-.06.12l0,0h-.06a.15.15,0,0,1-.12-.11v-2.68a.14.14,0,0,1,.14-.14.14.14,0,0,1,.14.14v.28a1.18,1.18,0,0,1,.91-.42,1.2,1.2,0,0,0,2.1,0,1.19,1.19,0,0,1,1.19,1.19v1.6a.13.13,0,0,1-.14.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.11,275.58v2.65a.14.14,0,0,1-.14.14.15.15,0,0,1-.15-.14v-.44a1.35,1.35,0,0,1-1.1.58,1.47,1.47,0,0,1,0-2.94,1.35,1.35,0,0,1,1.1.58v-.43a.15.15,0,0,1,.15-.15A.15.15,0,0,1,250.11,275.58Zm-.29,1.32a1.1,1.1,0,1,0-1.1,1.18A1.15,1.15,0,0,0,249.82,276.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,274.62a.15.15,0,0,1,.14-.15.15.15,0,0,1,.15.15v.14a.15.15,0,0,1-.15.15.15.15,0,0,1-.14-.15Zm0,1a.14.14,0,0,1,.14-.15.15.15,0,0,1,.15.15v2.65a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,274.32a.15.15,0,0,1,.14-.15.15.15,0,0,1,.15.15v3.91a.14.14,0,0,1-.15.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65,277.77a.3.3,0,1,1,0,.6.3.3,0,0,1,0-.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.46,276.9a1.51,1.51,0,0,1,2.45-1.14.14.14,0,0,1,0,.2.15.15,0,0,1-.2,0,1.2,1.2,0,1,0-.76,2.1,1.24,1.24,0,0,0,.76-.25.15.15,0,0,1,.2,0,.15.15,0,0,1,0,.21,1.55,1.55,0,0,1-.93.31A1.48,1.48,0,0,1,255.46,276.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.26,275.43a1.47,1.47,0,1,1-1.39,1.47A1.44,1.44,0,0,1,260.26,275.43Zm0,2.65a1.15,1.15,0,0,0,1.11-1.18,1.11,1.11,0,1,0-2.21,0A1.14,1.14,0,0,0,260.26,278.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,276.63a.92.92,0,0,0-.91-.91.9.9,0,0,0-.9.91v1.62h0v0a.12.12,0,0,1-.07.07.11.11,0,0,1-.07,0H265l0,0h0l0,0h0v0h0v0h0v-1.62a.91.91,0,1,0-1.81,0v1.6a.13.13,0,0,1-.07.12l0,0h-.06a.15.15,0,0,1-.12-.11v-2.68a.14.14,0,0,1,.14-.14.14.14,0,0,1,.14.14v.28a1.18,1.18,0,0,1,.91-.42,1.2,1.2,0,0,0,2.1,0,1.19,1.19,0,0,1,1.19,1.19v1.6a.14.14,0,0,1-.28,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.62 281.74 208.46 281.56 222.31 281.45 250 281.37 277.69 281.45 291.54 281.56 305.38 281.74 291.54 281.93 277.69 282.03 250 282.12 222.31 282.03 208.46 281.92 194.62 281.74",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.65,297.69h-.74V299a.34.34,0,0,1-.67,0v-3.54a.33.33,0,0,1,.33-.33h1.08a1.28,1.28,0,1,1,0,2.56Zm-.74-.66h.74a.62.62,0,1,0,0-1.24h-.74Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.46,298.33H199l-.29.78a.32.32,0,0,1-.31.21h-.12a.34.34,0,0,1-.19-.43l1.32-3.54a.36.36,0,0,1,.32-.21.35.35,0,0,1,.32.21l1.32,3.54a.34.34,0,0,1-.2.43h-.11a.32.32,0,0,1-.31-.21Zm-.25-.65-.48-1.29-.49,1.29Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,298.28a.32.32,0,0,1,.44,0,1.89,1.89,0,0,0,1.14.46,1.31,1.31,0,0,0,.75-.22.54.54,0,0,0,.26-.43.38.38,0,0,0-.05-.19.51.51,0,0,0-.18-.18,2.41,2.41,0,0,0-.82-.29h0a3,3,0,0,1-.78-.23,1.35,1.35,0,0,1-.56-.47.9.9,0,0,1-.13-.49,1.11,1.11,0,0,1,.48-.88,1.77,1.77,0,0,1,1-.31,2.34,2.34,0,0,1,1.31.48.29.29,0,0,1,.08.42.29.29,0,0,1-.42.09,1.78,1.78,0,0,0-1-.38,1.13,1.13,0,0,0-.67.2.48.48,0,0,0-.23.38.31.31,0,0,0,.05.17.47.47,0,0,0,.16.15,1.94,1.94,0,0,0,.75.27h0a3.85,3.85,0,0,1,.83.25,1.47,1.47,0,0,1,.6.5,1,1,0,0,1,.14.51,1.18,1.18,0,0,1-.52.93,1.9,1.9,0,0,1-1.11.34,2.61,2.61,0,0,1-1.53-.6A.33.33,0,0,1,202,298.28Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.9,298.28a.32.32,0,0,1,.44,0,1.92,1.92,0,0,0,1.15.46,1.31,1.31,0,0,0,.75-.22.52.52,0,0,0,.25-.43.3.3,0,0,0-.05-.19.51.51,0,0,0-.18-.18,2.33,2.33,0,0,0-.82-.29h0a3.09,3.09,0,0,1-.78-.23,1.32,1.32,0,0,1-.55-.47.91.91,0,0,1-.14-.49,1.11,1.11,0,0,1,.48-.88,1.8,1.8,0,0,1,1-.31,2.31,2.31,0,0,1,1.3.48.31.31,0,0,1,.09.42.3.3,0,0,1-.43.09,1.78,1.78,0,0,0-1-.38,1.19,1.19,0,0,0-.68.2.47.47,0,0,0-.22.38.31.31,0,0,0,0,.17.47.47,0,0,0,.16.15,2.08,2.08,0,0,0,.75.27h0a3.69,3.69,0,0,1,.83.25,1.47,1.47,0,0,1,.6.5,1,1,0,0,1,.14.51,1.17,1.17,0,0,1-.51.93,2,2,0,0,1-1.11.34,2.61,2.61,0,0,1-1.54-.6A.33.33,0,0,1,205.9,298.28Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.42,295.62l-1.47,3.5,0,.05h0l0,0h0l0,0h0a.13.13,0,0,1-.06,0h-.25a.09.09,0,0,1-.06,0h0l-.05,0h0s0,0,0,0h0s0,0,0-.05l-.78-1.86-.79,1.86,0,.05h0l0,0h0l0,0h0l-.05,0h-.26a.1.1,0,0,1-.05,0h0l0,0h0l0,0h0s0,0,0-.05l-1.47-3.5a.32.32,0,0,1,.18-.42.33.33,0,0,1,.43.17l1.17,2.78.77-1.84a.35.35,0,0,1,.32-.21.36.36,0,0,1,.31.21l.77,1.84,1.17-2.78a.34.34,0,0,1,.44-.17A.32.32,0,0,1,215.42,295.62Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.6,295.65a2.19,2.19,0,0,1,0,3,2,2,0,0,1-1.43.64,2,2,0,0,1-1.47-.64,2.21,2.21,0,0,1,0-3,2,2,0,0,1,1.47-.64A1.91,1.91,0,0,1,219.6,295.65Zm-.08,1.52a1.53,1.53,0,0,0-.41-1.05,1.28,1.28,0,0,0-.94-.43,1.29,1.29,0,0,0-1,.43,1.54,1.54,0,0,0,0,2.09,1.29,1.29,0,0,0,1,.43,1.28,1.28,0,0,0,.94-.43A1.52,1.52,0,0,0,219.52,297.17Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.17,298.83a.34.34,0,0,1-.21.42h-.14a.5.5,0,0,1-.24-.06.77.77,0,0,1-.19-.21,1.7,1.7,0,0,1-.12-.72.5.5,0,0,0-.08-.26.43.43,0,0,0-.18-.17,1.22,1.22,0,0,0-.33-.15H222V299a.33.33,0,0,1-.34.32.32.32,0,0,1-.32-.32v-3.54a.32.32,0,0,1,.32-.33h1.08a1.28,1.28,0,0,1,.81,2.27.88.88,0,0,1,.21.22,1.14,1.14,0,0,1,.2.65,1.28,1.28,0,0,0,0,.35A.34.34,0,0,1,224.17,298.83Zm-.84-2.41a.63.63,0,0,0-.62-.63H222V297h.74A.62.62,0,0,0,223.33,296.42Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.14,299v-3.54a.32.32,0,0,1,.33-.33h.71a2.1,2.1,0,0,1,0,4.19h-.71A.32.32,0,0,1,225.14,299Zm.66-.34h.38a1.44,1.44,0,0,0,0-2.87h-.38Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.84,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29s-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38-.05-.66a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l-.05.66.54-.38.1,0a.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13.26.26,0,0,1-.1,0l-.54-.37.05.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29c-.05,0-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38,0-.66a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l-.05.66.54-.38a.19.19,0,0,1,.1,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13s-.06,0-.1,0l-.54-.37.05.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29s-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38L201,308a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l-.05.66.55-.38a.16.16,0,0,1,.09,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13.18.18,0,0,1-.09,0l-.55-.37.05.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.58,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29c-.05,0-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38-.05-.66a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l-.05.66.54-.38a.19.19,0,0,1,.1,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13s-.06,0-.1,0l-.54-.37.05.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.16,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29s-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38,0-.66a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l0,.66.54-.38a.19.19,0,0,1,.1,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13s-.06,0-.1,0l-.54-.37,0,.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.74,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29c-.05,0-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38-.05-.66a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l-.05.66.54-.38a.19.19,0,0,1,.1,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13s-.06,0-.1,0l-.54-.37.05.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,308.93l-.54.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.61-.3-.61-.29s-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.54.38,0-.66a.11.11,0,0,1,.12-.13.12.12,0,0,1,.12.13l0,.66.54-.38a.19.19,0,0,1,.1,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13s-.06,0-.1,0l-.54-.37,0,.65a.12.12,0,0,1-.12.13.11.11,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.9,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29c-.05,0-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38-.05-.66a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l-.05.66.54-.38a.19.19,0,0,1,.1,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13s-.06,0-.1,0l-.54-.37.05.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.48,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.61-.3-.61-.29c-.05,0-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38,0-.66a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l0,.66.54-.38a.19.19,0,0,1,.1,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13s-.06,0-.1,0l-.54-.37,0,.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.06,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29s-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38L219,308a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l-.05.66.54-.38a.19.19,0,0,1,.1,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13s-.06,0-.1,0l-.54-.37.05.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.64,308.93l-.55.37s-.06,0-.1,0a.12.12,0,0,1,0-.24l.62-.3-.62-.29c-.05,0-.09-.06-.09-.12a.13.13,0,0,1,.12-.12.17.17,0,0,1,.1,0l.55.38,0-.66a.12.12,0,0,1,.12-.13.12.12,0,0,1,.12.13l-.05.66.55-.38a.14.14,0,0,1,.09,0,.12.12,0,0,1,.12.12.12.12,0,0,1-.08.12l-.62.29.62.3a.1.1,0,0,1,.08.11.12.12,0,0,1-.12.13.15.15,0,0,1-.09,0l-.55-.37.05.65a.12.12,0,0,1-.12.13.12.12,0,0,1-.12-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.62 315.5 208.46 315.31 222.31 315.21 250 315.12 277.69 315.21 291.54 315.31 305.38 315.5 291.54 315.68 277.69 315.78 250 315.87 222.31 315.78 208.46 315.68 194.62 315.5",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.16,
    y: 304.52,
    width: 0.5,
    height: 8.98,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.27,
    y: 340.87,
    width: 81.46,
    height: 25.61,
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,357v-5.31a.5.5,0,0,1,1,0v4.81h2.44a.51.51,0,0,1,.5.5.51.51,0,0,1-.5.5h-2.94A.5.5,0,0,1,236.25,357Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.93,352a3.3,3.3,0,0,1,.91,2.28,3.26,3.26,0,0,1-.91,2.27,2.93,2.93,0,0,1-2.15,1,3,3,0,0,1-2.21-1,3.24,3.24,0,0,1-.89-2.27,3.28,3.28,0,0,1,.89-2.28,3,3,0,0,1,2.21-1A2.92,2.92,0,0,1,245.93,352Zm-.12,2.28a2.35,2.35,0,0,0-.61-1.58,2,2,0,0,0-1.42-.64,2,2,0,0,0-1.46.64,2.3,2.3,0,0,0-.61,1.58,2.22,2.22,0,0,0,.61,1.56,2,2,0,0,0,1.46.65,1.93,1.93,0,0,0,1.42-.65A2.26,2.26,0,0,0,245.81,354.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.33,354.29a3.28,3.28,0,0,1,3.32-3.25,3.35,3.35,0,0,1,2.06.7.51.51,0,0,1,.09.73.52.52,0,0,1-.72.08,2.35,2.35,0,0,0-1.43-.49,2.26,2.26,0,0,0-1.62.66,2.16,2.16,0,0,0-.67,1.57,2.13,2.13,0,0,0,.67,1.54,2.22,2.22,0,0,0,1.62.66,2.48,2.48,0,0,0,1.24-.34v-1.23H251.6a.52.52,0,0,1-.51-.52.5.5,0,0,1,.51-.5h1.79a.51.51,0,0,1,.52.5v2c0,.07,0,.1,0,.16l0,0h0a.49.49,0,0,1-.17.22,3.34,3.34,0,0,1-2,.7A3.27,3.27,0,0,1,248.33,354.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,351.71a.48.48,0,0,1,.49-.49.5.5,0,0,1,.51.49V357a.51.51,0,0,1-.51.5.49.49,0,0,1-.49-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.67,357a.49.49,0,1,1-1,0v-5.23h0a.47.47,0,0,1,.2-.41.49.49,0,0,1,.68.11l2.91,4v-3.71a.49.49,0,0,1,1,0V357a.5.5,0,0,1-.49.5.47.47,0,0,1-.37-.18l-.05-.06-2.88-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.14,375.91a.14.14,0,0,1,.14-.14h2.17a.14.14,0,0,1,.14.14.15.15,0,0,1-.14.15h-2v1.66h1.76a.15.15,0,0,1,0,.3h-1.76v1.8a.15.15,0,0,1-.15.15.15.15,0,0,1-.14-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.52,377a1.47,1.47,0,1,1-1.39,1.47A1.44,1.44,0,0,1,228.52,377Zm0,2.65a1.19,1.19,0,1,0-1.11-1.18A1.15,1.15,0,0,0,228.52,379.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.89,377.18A.15.15,0,0,1,231,377a.14.14,0,0,1,.14.15v.65l0-.08a1.46,1.46,0,0,1,1.18-.72.14.14,0,0,1,.14.15.14.14,0,0,1-.14.14,1.07,1.07,0,0,0-.85.48,2.85,2.85,0,0,0-.36.68.13.13,0,0,0,0,0v1.29a.14.14,0,0,1-.14.15.15.15,0,0,1-.15-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09,379.73a1.38,1.38,0,0,1-1.38,1.38,1.4,1.4,0,0,1-.61-.14.15.15,0,0,1-.06-.19.13.13,0,0,1,.19-.07,1,1,0,0,0,.48.11,1.09,1.09,0,0,0,1.1-1.09v-.36a1.33,1.33,0,0,1-1.1.58,1.46,1.46,0,0,1,0-2.92,1.35,1.35,0,0,1,1.1.57v-.43A.14.14,0,0,1,236,377a.13.13,0,0,1,.13.14Zm-.28-1.25a1.1,1.1,0,1,0-2.19,0,1.1,1.1,0,1,0,2.19,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.74,377a1.47,1.47,0,1,1-1.39,1.47A1.44,1.44,0,0,1,238.74,377Zm0,2.65a1.19,1.19,0,1,0-1.1-1.18A1.15,1.15,0,0,0,238.74,379.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.15,377.17a.16.16,0,0,1-.15.15h-.37v2.14a.22.22,0,0,0,.21.21.15.15,0,0,1,0,.3.5.5,0,0,1-.51-.51v-2.14H241c-.14,0-.14-.08-.14-.15s0-.14.14-.14h.37v-1.09a.15.15,0,0,1,.14-.15.16.16,0,0,1,.16.15V377H242A.15.15,0,0,1,242.15,377.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.32,378.54v-1.37a.15.15,0,0,1,.3,0v.43a1.36,1.36,0,0,1,1.11-.57,1.43,1.43,0,0,1,1.42,1.45,1.45,1.45,0,0,1-1.42,1.47,1.37,1.37,0,0,1-1.11-.58v1.68a.15.15,0,0,1-.3,0Zm.3-.06a1.12,1.12,0,1,0,2.24,0,1.12,1.12,0,1,0-2.24,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.75,377.17v2.65a.15.15,0,1,1-.29,0v-.44a1.36,1.36,0,0,1-1.1.59,1.47,1.47,0,0,1,0-2.94,1.35,1.35,0,0,1,1.1.57v-.43a.14.14,0,0,1,.14-.14A.15.15,0,0,1,251.75,377.17Zm-.29,1.33a1.11,1.11,0,1,0-1.1,1.18A1.15,1.15,0,0,0,251.46,378.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.79,379.35a.14.14,0,0,1,.21,0,1.54,1.54,0,0,0,.9.34.86.86,0,0,0,.55-.18.45.45,0,0,0,.23-.36.46.46,0,0,0-.21-.36,1.47,1.47,0,0,0-.63-.22h0a1.65,1.65,0,0,1-.66-.23.61.61,0,0,1-.32-.53.74.74,0,0,1,.32-.58,1.3,1.3,0,0,1,.71-.19,1.62,1.62,0,0,1,.88.31.16.16,0,0,1,0,.21.14.14,0,0,1-.2,0,1.29,1.29,0,0,0-.72-.29.86.86,0,0,0-.55.16.46.46,0,0,0-.19.34.34.34,0,0,0,.17.29,1.43,1.43,0,0,0,.6.21h0a1.86,1.86,0,0,1,.71.24.7.7,0,0,1,.33.6.74.74,0,0,1-.33.59,1.23,1.23,0,0,1-.73.24,1.82,1.82,0,0,1-1.09-.42A.15.15,0,0,1,252.79,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.69,379.35a.13.13,0,0,1,.2,0,1.57,1.57,0,0,0,.9.34.89.89,0,0,0,.56-.18.41.41,0,0,0,0-.72,1.47,1.47,0,0,0-.63-.22h0a1.65,1.65,0,0,1-.66-.23.61.61,0,0,1-.32-.53.74.74,0,0,1,.32-.58,1.34,1.34,0,0,1,.72-.19,1.62,1.62,0,0,1,.87.31.15.15,0,0,1,0,.21.13.13,0,0,1-.19,0,1.35,1.35,0,0,0-.72-.29.89.89,0,0,0-.56.16.46.46,0,0,0-.19.34.36.36,0,0,0,.17.29,1.43,1.43,0,0,0,.6.21h0a2,2,0,0,1,.72.24.72.72,0,0,1,.33.6.75.75,0,0,1-.34.59,1.18,1.18,0,0,1-.73.24,1.82,1.82,0,0,1-1.09-.42A.14.14,0,0,1,255.69,379.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.73,379.94s0,0-.06-.06l-1.1-2.63a.16.16,0,0,1,.07-.19.15.15,0,0,1,.19.08l1,2.32.67-1.62a.16.16,0,0,1,.29,0l.67,1.62,1-2.32a.14.14,0,0,1,.18-.08.15.15,0,0,1,.08.19l-1.1,2.61a.22.22,0,0,1-.05.08l-.07,0h0a.16.16,0,0,1-.12-.09h0l-.69-1.63-.68,1.62v0a.15.15,0,0,1-.13.09l-.05,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,377a1.47,1.47,0,1,1-1.39,1.47A1.44,1.44,0,0,1,265,377Zm0,2.65a1.19,1.19,0,1,0-1.1-1.18A1.15,1.15,0,0,0,265,379.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4,377.18a.14.14,0,0,1,.15-.15.14.14,0,0,1,.13.15v.65l.05-.08a1.43,1.43,0,0,1,1.17-.72.15.15,0,0,1,.15.15.15.15,0,0,1-.15.14,1.07,1.07,0,0,0-.85.48,2.42,2.42,0,0,0-.35.68s0,0,0,0v1.29a.14.14,0,0,1-.13.15.14.14,0,0,1-.15-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23,379.4a1.42,1.42,0,0,1-1.13.57,1.47,1.47,0,0,1,0-2.94,1.39,1.39,0,0,1,1.13.57v-1.69a.15.15,0,0,1,.3,0v3.91a.15.15,0,0,1-.3,0Zm0-.85v-.1a1.17,1.17,0,1,0,0,.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.52,378.24h0a.14.14,0,0,1,.14-.14,1,1,0,1,0,0-2,1,1,0,0,0-.87.51.16.16,0,0,1-.2.05.13.13,0,0,1,0-.19,1.27,1.27,0,0,1,1.11-.65,1.29,1.29,0,0,1,.15,2.58V379a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14Zm0,1.46a.15.15,0,1,1,.29,0v.13a.15.15,0,0,1-.15.14.14.14,0,0,1-.14-.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.55,77.08H240.44a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h19.11a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.55,77.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.31,129.43l-.4.1a.24.24,0,0,1,.07-.12h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.34,178h0",
    style: {
      fill: "none",
      stroke: "#ff98b9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.63,
    y: 160.83,
    width: 0.01,
    height: 7.04,
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.64,160.83v8.92c0-.11,0-.23,0-.35v-8.57Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.34,178h0",
    style: {
      fill: "none",
      stroke: "#ff98b9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.82,418.33l-.18,0v-.13Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,426.86c-2.2-1-50.6-44.76-51.39-47.6-.31-1.07,5.66-8.49,13.13-17.26,1.61-1.89,20.43-32,20.43-32l33.91,26.89-23.06,33.29s11,25.06,11.56,28.27S395.32,427.83,393.12,426.86Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.74,407.9a93.42,93.42,0,0,1,4,10.51c.52,3.21-2.38,9.42-4.58,8.45s-50.61-44.76-51.39-47.59c-.25-.88,3.62-5.93,9.09-12.48,9.78,11.36,40.62,46.72,42.88,43.43A4.39,4.39,0,0,0,393.74,407.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.09,356.35l34.3,28.3s47.71-66.43,49.08-90.71c1-18.67-26.66-53.46-45.48-83.24-1.82-2.89-.71-13.85-.64-15.68l-37.29.07c-.45,4.2-3.37,25.33,2.91,35.62,12.92,21.16,33.78,51.87,34.58,58.52S358.09,356.35,358.09,356.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.6,374.25c-5.48-4.64-3.84-3.38-9.37-8-2.71-2.24-16.28-13.54-19.15-15.22-.07,0-.14.06-.09.11,2.22,2.47,16,13.48,18.78,15.68,5.61,4.48,4.05,3.13,9.71,7.55A.1.1,0,1,0,394.6,374.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.85,283c-1.25-2.44-2.59-4.84-4-7.21C392.05,271,389,266.37,386,261.7q-4.69-7.32-9.4-14.62c-2.82-4.38-5.68-8.75-8.13-13.35a52.26,52.26,0,0,1-5.41-14.39c-1.1-5.54-.87-11.24-.39-16.84.12-1.4.25-2.79.38-4.19,0-.24-.39-.29-.42-.05a89.88,89.88,0,0,0-.79,16.55,44.37,44.37,0,0,0,3.82,14.69A101.81,101.81,0,0,0,373,242.8c3,4.73,6,9.43,9,14.13s6.13,9.51,9.12,14.31c1.46,2.33,2.89,4.68,4.25,7.07a71.42,71.42,0,0,1,3.8,7.25,11.75,11.75,0,0,1,1.05,3.93,9.64,9.64,0,0,1-.76,4.1c-1,2.57-2.34,5-3.56,7.5-2.44,4.93-4.92,9.84-7.48,14.71-5.14,9.77-19,32.77-19.73,33.95-.05.09.08.16.14.08,5.89-9.41,13.05-20.37,18.35-30.13q4-7.31,7.73-14.74,1.88-3.7,3.68-7.46c1.1-2.28,2.37-4.63,2.44-7.22S400,285.27,398.85,283Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05,195c-2.4,12.32-9.34,47.76-13.14,67.36-6.52-10.42-14.06-22-19.94-31.67-6.28-10.29-3.36-31.42-2.91-35.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.31,451.53c-2.29.73-67.56-.19-70-1.8-.94-.61-1.36-10.12-1.54-21.63,0-2.48.55-40.37.55-40.37l43.66.49-2.13,40.35s24.84,11.53,27.35,13.59S403.6,450.8,401.31,451.53Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.25,436.88a95.07,95.07,0,0,1,9.92,5.28c2.51,2.06,4.43,8.64,2.14,9.36s-67.56-.18-70-1.79c-.77-.49-1.19-6.84-1.41-15.37,14.84,2.07,61.35,8.25,60.87,4.29C390.71,438.28,390.14,437.65,389.25,436.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.35,195.09s-7.39,36-7.78,37.15a93.7,93.7,0,0,0-10.5,5.21l-2.64,183-47.08.31s5.84-97,5.67-103.24c-.26-10,4.07-77.64,3.47-79.34-6.15-17.36,3.5-43,3.5-43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.66,411.72c-13.28-.57-39-.33-42.25.23-.07,0-.07.14,0,.15,3.29.53,34.5.59,42.25-.17A.11.11,0,0,0,372.66,411.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,365.14c.75-13.76,1.56-27.52,2.35-41.28s1.57-27.53,2.36-41.29c.39-6.88.76-13.76,1.18-20.64l.63-10.32a89.59,89.59,0,0,0,.44-10.22c-.19-3.72-1.82-7-2.75-10.55A41.37,41.37,0,0,1,341,220.51c0-7.18,1.45-14.28,2.82-21.29.08-.39.68-.22.6.17A102.75,102.75,0,0,0,341.53,219a42.12,42.12,0,0,0,.85,9.83c.67,3.1,2,6,2.8,9s.45,6.44.25,9.66c-.21,3.44-.38,6.88-.56,10.32-.37,6.74-.77,13.48-1.15,20.23-1.57,27.38-3.09,54.77-4.76,82.15C338,375.6,337.27,391,336,406.43c0,.11-.19.11-.18,0C336.34,392.66,337.24,378.9,338,365.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08,216.65c.79-.32,1.67-.42,2.48-.67a20.57,20.57,0,0,0,2.52-.93,19,19,0,0,0,4.32-2.71,10.08,10.08,0,0,0,2.76-4.17c.34-.85.66-1.71,1-2.57.16-.42.33-.85.5-1.27.06-.17.5-1.07.57-1.35a.08.08,0,0,1-.11,0l-.05,0a.09.09,0,0,1,0-.11c.05-.1.06-.11.17-.14a.11.11,0,0,1,.12.05c.17.28,0,.55-.06.85-.13.57-.26,1.13-.4,1.69-.25,1-.48,2-.76,2.94a9.9,9.9,0,0,1-2.76,4.79,15.45,15.45,0,0,1-4.82,2.88,17.14,17.14,0,0,1-2.79.82,7.59,7.59,0,0,1-2.68.2C344.92,216.89,345,216.7,345.08,216.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.11,226.52c.08-1.65.18-3.29.3-4.94.26-3.76.59-7.53,1.18-11.24.05-.3.46-.19.44.08-.2,2.92-.49,5.84-.71,8.75s-.52,5.82-.52,8.72c0,.87.08,2.35,1.16,2.58,1.44.3,2.09-1.61,2.42-2.65a47.92,47.92,0,0,0,1.67-8c.42-3.07.62-6.17.86-9.25,0-.11.19-.1.2,0,.12,6.11.14,12.5-2,18.31a3.41,3.41,0,0,1-2.49,2.46h-.06s0,.07,0,.1-.07.35-.09.52-.05.28-.08.43-.09.59-.16.89a.23.23,0,0,1-.45,0,.2.2,0,0,1-.13-.18,5,5,0,0,1,.37-1.74,2.15,2.15,0,0,1-1.6-1.3A7.61,7.61,0,0,1,383.11,226.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.61,231.89a87,87,0,0,0-13.33,7.28c-.17.11,0,.37.14.27,4.5-2.28,9.1-4.48,13.47-7A.3.3,0,0,0,387.61,231.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.74,327.9c0-.44.14-.61.16-.07.11,3,.07,7.39.1,10.43,0,3.58,0,7.15,0,10.72s-.13,7.15-.27,10.73l-.22,5.35c-.07,1.24,0,3.68-.12,4.91,0,.55-.17.65-.22.1-.09-1.79-.09-3.22-.15-5l-.06-5.37c0-3.57,0-7.15,0-10.72s.13-7.15.27-10.72S375.48,331.47,375.74,327.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.23,144.31a.53.53,0,0,1-.39.59l-2.11.2c-2.11-5.24-4.33-9.39-3.73-7.76a28.94,28.94,0,0,1,1.65,7.94l-4.17.32c-2-9.27-4.42-16.11-4.2-14,.88,8.57.52,11.34.09,14.3-10.07.74-23.28,1.54-32.84,1.91-1.32-5.11-2.51-10.66-2.67-10.26-1.18,2.93-1.36,7.15-1.26,10.4-3.05.09-5.48.11-7,0,0,0-.89-4.31-1.05-5.73a31.41,31.41,0,0,1,.62-10.85,54.84,54.84,0,0,1,4-10.15l0-.07s0,0,0,0a31.22,31.22,0,0,0,2.28-6.77.2.2,0,0,0,0-.05,30.84,30.84,0,0,0,.58-5.17c.18-6.36,3.3-11.92,8.81-13.73,10.09-10.86,20.83-6.64,24.35,1.42.34.79.68,1.69,1,2.68v0c1.23,3.64,2.39,8.38,3.43,12v0s0,0,0,0h0a38.4,38.4,0,0,0,1.42,4.22C391.12,122.47,397.36,126.09,399.23,144.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.58,97.26a11.7,11.7,0,0,0-6.08,9.8,32.78,32.78,0,0,1-1.14,7.92,27.58,27.58,0,0,1-3.93,7,20.85,20.85,0,0,0-4.33,11.49c-.21,4.63.22,10.08,1.85,14.35,0,0,0,0,0,0a39.5,39.5,0,0,1-1.1-15c.59-5,3.12-8.27,5.68-12.15a21.4,21.4,0,0,0,3.58-10.36c.18-2.29.05-4.68.83-6.85.92-2.6,2.9-4.29,4.88-5.79C356.12,97.51,355.85,97.09,355.58,97.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.62,122.87c-2.73-3.54-5.55-6.55-7.25-11-1.54-4-2.51-8.31-4.08-12.34,0-.07-.11,0-.09,0,2.46,7.16,3.18,14.44,7.79,20.4,2.5,3.24,5,6.24,6.72,10.16a37.77,37.77,0,0,1,3,13,.11.11,0,1,0,.21,0A31,31,0,0,0,394.62,122.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.93,103.23l-6.47,29.64c-.29.88.16,1.56,1,1.54l15.17-.48a2.47,2.47,0,0,0,2.06-1.64l6.48-29.63c.28-.88-.17-1.56-1-1.54L421,101.6A2.47,2.47,0,0,0,418.93,103.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.73,103.16l-6.47,29.64c-.29.87.16,1.56,1,1.53l15.18-.48a2.46,2.46,0,0,0,2.05-1.63L439,102.58c.28-.87-.17-1.56-1-1.53l-15.17.48A2.47,2.47,0,0,0,420.73,103.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.93,104.37a1.29,1.29,0,0,1-1.27,1.31,1.29,1.29,0,1,1,0-2.58A1.28,1.28,0,0,1,424.93,104.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.44,149.31c9,18.09,28.83,41.4,36.81,41.33,3.8,0,10.59.71,15.48-3.76,10.65-9.77,19.32-28.18,20.93-38.64.57-3.73-17.64-11.34-20.23-8.26-6.08,7.21-13,21.24-14.11,21.18C406.23,161,390,148,378.59,138.91,364.8,127.85,367.85,142.1,371.44,149.31Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.67,129.07c-2.08-7.48-3.76-9.08-2.17-16.33,1.05-4.75-1.54-7.46-4.8-3.59-5.34,6.33-4.68,16.55-3.44,20Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.85,151.48s3.12-10.56,1.69-18.75c-1-5.66-4.51-17.75-20.57-23.8-3.81-1.44-10.25-.78-4.88,3.82,3.81,3.27,7.22,4.19,9.09,6.5,0,0-8.1,1.81-9.39,5.68a76,76,0,0,0-2.65,10.36,15.89,15.89,0,0,0,1.9.67s-.86,3.73,1.95,8.83Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.74,127.47c-2.34-1.89-7.38-5.83-12.61-7.62-5.82-2-17.56-4.24-19,.07-1,3.16,3.37,4.41,3.37,4.41s-5,.09-5.37,3.15c-.29,2.79,3.18,3.56,3.18,3.56s-3.06.58-2.82,3.32c.29,3.29,6.64,1.54,9.81,4.62C421,139.68,443.74,127.47,443.74,127.47Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.05,126.35a24.45,24.45,0,0,0-14.44-2.1c-.12,0-.17.13-.05.13a60.82,60.82,0,0,1,14.48,2S430.08,126.37,430.05,126.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.88,132.16c-2.28-1-9.06-2.54-14.55-1.23-.12,0-.16.14,0,.13a64.46,64.46,0,0,1,14.57,1.16S427.91,132.17,427.88,132.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.72,165.72l15-15.71s-11.2-10.23-19.42-14.22-9.57,1.35-6.16,9.58S379.72,165.72,379.72,165.72Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.72,165.72l15-15.71s-11.2-10.23-19.42-14.22-9.57,1.35-6.16,9.58S379.72,165.72,379.72,165.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.58,181.38l7.05,33.07s-54.36,4.38-67.93,4.32c0,0,6.91-63.15,20.4-79.87,6.75-8.37,15.32-8.34,21.11-3.18,1.47,1.31,19.31,21.92,21.58,30.09C397.78,173,393.58,181.38,393.58,181.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.21,132.51h-5.77A12.23,12.23,0,0,1,368.21,132.51Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.15,135.67H356.27c.25-.21.51-.41.77-.59h16.4C373.68,135.27,373.92,135.46,374.15,135.67Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,138.83H353.16l.49-.59h22.86Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.7,142H351c.11-.2.23-.4.36-.59h27.86Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.29,145.15h-33c.09-.2.19-.4.29-.59h32.24Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.79,148.31h-37c.09-.2.17-.4.25-.59h36.24Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.2,151.47H346.59l.22-.6h39.94Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.49,154.63h-44c.07-.21.13-.4.2-.6h43.4Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.64,157.79H344.42l.2-.6h46.62Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.57,161H343.48c0-.21.11-.4.17-.6h49.57C393.35,160.55,393.46,160.75,393.57,161Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.18,164.11H342.59c.05-.2.11-.4.16-.6h52.16Q395.06,163.81,395.18,164.11Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.11,167.26H341.76l.15-.59H396C396,166.87,396.08,167.06,396.11,167.26Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.33,169.83c0,.2,0,.4,0,.59H341c0-.2.1-.4.14-.59Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.12,173c0,.2-.06.4-.1.59H340.25c0-.19.08-.39.13-.59Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.47,176.15c-.05.2-.1.4-.16.59H339.54c0-.2.09-.39.13-.59Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.46,179.31l-.23.59H338.88c0-.2.07-.39.12-.59Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.94,183.06h-55.7c0-.2.07-.39.12-.59h55.45Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.61,186.22h-57c0-.2.07-.39.11-.59h56.75Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.29,189.38H337.05c0-.2.07-.4.1-.6h58Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,192.54H336.49c0-.2.07-.4.1-.6h59.24Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.63,195.7H336c0-.2.06-.4.1-.6H396.5Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.31,198.86H335.45l.09-.6h61.64Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,202H335c0-.2.07-.4.1-.6h62.8Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.65,205.17H334.48l.09-.59h64Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.33,208.33H334l.09-.59H399.2Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,211.49H333.6c0-.19.06-.39.08-.59h66.19Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.63,214.45l-2.48.2H333.2c0-.19,0-.38.07-.59h67.28Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.29,217.22c-3.08.21-6.14.41-9.09.59H332.81c0-.17,0-.37.07-.59Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.49,175.74a20.23,20.23,0,0,0,.42-6,28,28,0,0,0-4.07-11.39c-1.17-2-2.57-3.84-3.73-5.83a.05.05,0,1,1,.08-.06,41.81,41.81,0,0,1,3,4.08.61.61,0,0,0-.07-.14c-.32-.78-.65-1.55-1-2.31,0-.08.1-.15.14-.07.4.74.78,1.48,1.14,2.23.22.49.41,1,.58,1.48a37.47,37.47,0,0,1,3,5.46,18.91,18.91,0,0,1,1.41,12,21.47,21.47,0,0,1-2.73,6.17.08.08,0,0,1-.14-.07,29.9,29.9,0,0,0,2-5.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.55,136.37c.41,1,6.53,7.12,11.34,6.14,1.56-.32.19-8.94.19-8.94l0-.66.62-9.23-11.53-5.1-1.65-.66s0,2.54,0,5.7v1c0,.47,0,1,0,1.44s0,.72,0,1.1,0,.76,0,1.14A58.49,58.49,0,0,0,361.55,136.37Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.59,123.62a18.58,18.58,0,0,0,12.53,9.29l.62-9.23-11.53-5.1-1.65-.66S360.56,120.46,360.59,123.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.11,109.82c1.69,16.15-7.79,19-11.27,19.34-3.16.33-14,1-17.32-14.84s3.62-21.78,10.82-22.91S383.42,93.67,385.11,109.82Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.52,106.34a10.43,10.43,0,0,1-1.11-.11,1.79,1.79,0,0,1-1.12-.34.58.58,0,0,1-.07-.7,1.42,1.42,0,0,1,1.37-.48,2.13,2.13,0,0,1,1.39.6A.61.61,0,0,1,381.52,106.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.89,107.57a9.52,9.52,0,0,0,1.07-.34,1.78,1.78,0,0,0,1-.56.57.57,0,0,0-.07-.7,1.46,1.46,0,0,0-1.44-.19,2.14,2.14,0,0,0-1.24.88A.61.61,0,0,0,370.89,107.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.74,111.42s-.08.06-.07.11c.17,1.09.19,2.37-.75,2.86,0,0,0,.07,0,.06C374.12,114.13,374.08,112.43,373.74,111.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.61,110.4c-1.78.1-1.46,3.65.19,3.56S374.11,110.32,372.61,110.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.93,110.65c-.29.23-.56.61-.93.69s-.79-.27-1.11-.6c0,0-.06,0-.06.05.05.68.38,1.36,1.12,1.39s1.1-.61,1.21-1.31C372.18,110.74,372.05,110.56,371.93,110.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.82,110.59s.09,0,.09.09c.06,1.11.31,2.36,1.33,2.65,0,0,0,.06,0,.06C380,113.32,379.69,111.65,379.82,110.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.71,109.36c1.76-.28,2.19,3.27.56,3.52S379.23,109.6,380.71,109.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.48,109.51c.3.15.62.46.95.44s.64-.44.84-.84c0,0,.05,0,.06,0,.1.68,0,1.41-.67,1.62s-1.09-.34-1.33-1C381.28,109.65,381.35,109.44,381.48,109.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.63,120.22c.28.24.56.59,1,.6a2.71,2.71,0,0,0,1.17-.33s.07,0,.05.06a1.48,1.48,0,0,1-1.37.66,1.18,1.18,0,0,1-.91-.94C374.51,120.21,374.59,120.18,374.63,120.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.83,115.77s.39,1.62.47,2.4c0,.07-.18.12-.44.17h0a3.72,3.72,0,0,1-3.72-1c-.06-.07,0-.16.11-.12a5.62,5.62,0,0,0,3.46.62c0-.22-.77-2.75-.65-2.77a6.55,6.55,0,0,1,1.8.22c-.72-3.4-2-6.65-2.65-10a.11.11,0,0,1,.2-.07,56.83,56.83,0,0,1,3.32,10.7C380.8,116.29,379.15,115.87,378.83,115.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,118.15a4.38,4.38,0,0,1-1.55,1.58,2,2,0,0,1-1.18.24c-.89-.11-1-.89-.95-1.59a4.66,4.66,0,0,1,.24-1.08A5.67,5.67,0,0,0,378.67,118.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.12,119.73a2,2,0,0,1-1.18.24c-.89-.11-1-.89-.95-1.59A2.05,2.05,0,0,1,377.12,119.73Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.75,113.63c3,.49,4-6.28,4-6.28s12.74-1.63,14.22-11.88a17.48,17.48,0,0,0,8.41,9.89s0-11.31-8.85-13.86c0,0-10.94-4.5-17.54,4.07S355.77,113.3,357.75,113.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,94.71a11.24,11.24,0,0,1-.76,4.68,11.76,11.76,0,0,1-2.55,4.06,11.52,11.52,0,0,1-.89.82l-.45.4-.5.34c-.34.22-.67.45-1,.65s-.72.36-1.08.53c-.18.08-.36.18-.54.25l-.57.2-1.13.38c-.77.18-1.55.32-2.33.45.74-.29,1.5-.49,2.22-.78l1.07-.47.53-.23.5-.29c.34-.2.67-.39,1-.57s.62-.45.93-.67l.47-.34.42-.38a8.89,8.89,0,0,0,.83-.79,13.92,13.92,0,0,0,3.36-6A13.48,13.48,0,0,0,376,94.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.58,115s-3.63-5-5.91-3.7.52,8.6,3.24,9.56a2.75,2.75,0,0,0,3.65-1.54Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.52,113.41a0,0,0,0,0,0,.07c1.91.74,2.94,2.47,3.67,4.28a1.52,1.52,0,0,0-2.28-.37s0,.11.05.1a1.68,1.68,0,0,1,1.87.55,8.79,8.79,0,0,1,.92,1.49c.09.17.4.07.33-.12l0,0C359.06,117,357.12,113.61,354.52,113.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.26,95.39c1.45-.54,2.83-8.65-2.5-12.52s-12.16.55-9.3,7.2C349.27,94.27,356.19,96.53,359.26,95.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,82.4a9.07,9.07,0,0,0-3.07,5.14,5.46,5.46,0,0,0,1.62,5.22,10.94,10.94,0,0,0,5.29,2.59,16.42,16.42,0,0,0,3.05.38,8.64,8.64,0,0,0,3.07-.34,7.34,7.34,0,0,1-3.05.9,13.35,13.35,0,0,1-3.22-.05,10.61,10.61,0,0,1-5.94-2.64,6.38,6.38,0,0,1-1.76-2.91,6.59,6.59,0,0,1,.06-3.36A8,8,0,0,1,349.3,82.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,140.18c-13.38,20.13-20.94,46.93-20,52.83,1.08,6.49,10.24,28.43,19.68,38.1,2.49,2.55,21.35-18.37,18.8-21.2-4.91-5.46-14.66-21.55-15.09-25.22-.4-3.39,4.54-25.2,5.84-37.6C362.63,135.18,358.32,130.81,352.1,140.18Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,209.24s10.24,4.5,16.8,7.76c3.66,1.82,9.66,5.5,11.74,8.07,3.1,3.83,13.65,21.87,9.33,24.52-3.91,2.4-11-14.24-11-14.24s8.64,16.16,3.4,18.19-10.75-17.86-10.75-17.86,8.51,16.81,2.78,18C388,254.66,382,236.94,382,236.94s7.21,14.5,2.8,15.65c-4.88,1.27-11.45-14.74-11.45-14.74-11.71,1-17.71-3.27-21.61-6.83C350.78,230.16,370,209.24,370,209.24Z",
    style: {
      fill: "rgb(235, 148, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.27,229.56c1.08,1.86,2.19,3.74,3.11,5.69s1.76,3.94,2.49,6a36.79,36.79,0,0,1,2.08,8.16c-1-4.9-4.2-11.94-5.12-13.89s-1.73-4-2.64-5.9C394.17,229.55,394.24,229.52,394.27,229.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.16,232.74c1.28,2.43,2.64,4.81,3.82,7.3s2,4.94,3,7.5c.07.2-.06.17-.14,0-1.1-2.52-2.3-4.76-3.43-7.26s-2.15-5-3.36-7.5C387.08,232.72,387.14,232.7,387.16,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.57,234.36a62.1,62.1,0,0,1,5,11.62c.07.2-.1.15-.18,0-1.58-3.89-2.8-7-4.93-11.49C380.41,234.37,380.52,234.29,380.57,234.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.24,160.83l21.32,4.11s2.55-14.95,1.46-24-6.31-7.31-11.38,0S339.24,160.83,339.24,160.83Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.24,160.83l21.32,4.11s2.55-14.95,1.46-24-6.31-7.31-11.38,0S339.24,160.83,339.24,160.83Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.6,343.45c-1.16,4.93-2.39,9.78-2.63,14.84.14.25.11,1.17,0,.92,0,.82-1.27.67-1.27-.14,0-.52,0-1.05,0-1.55-2.9-3.61-7.11-5.89-10.51-9a19.76,19.76,0,0,1-5.76-9.17c-2.82-9.73-.18-20-3.57-29.75-2.93-8.36-8.18-15.64-12.62-23.22-4.69-8-8.15-16.44-8.5-25.83-.27-7.19.58-16.77,6.06-22.15,5.8-5.72,13-1.44,17.45,3.66,12.88,14.79,18.84,33.48,21.25,52.59,1.33,10.58,2.71,21.22,2.39,31.89A86,86,0,0,1,121.6,343.45Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,362.18a182.85,182.85,0,0,0-.35-30,.93.93,0,0,0,0-.1c.16-8.1.8-16.17.48-24.28a143.87,143.87,0,0,0-3.56-26c0-.1-.18-.07-.16,0a170.1,170.1,0,0,1,2.82,25.46q.24,6.87-.11,13.73c-.08,1.49-.22,3-.32,4.49v0a160.16,160.16,0,0,0-24.1-63.77c-.16-.26-.63,0-.47.29a166.42,166.42,0,0,1,19.62,47.28c-6.2-11.48-15.56-20.92-22.5-31.95,0-.06-.14,0-.11.06,6.24,12.29,16.55,22,23.12,34.07,1.13,4.93,2.07,9.91,2.76,14.92a167.31,167.31,0,0,1,1.5,20.72c-3.78-7.05-7.7-13.8-10.78-21.26a.16.16,0,0,0-.3.13c2.62,7.75,6.15,16.1,11.1,22.71q0,7.36-.41,14.72c-.77,13.08-3,26-4,39a.3.3,0,0,0,.6.07A298.62,298.62,0,0,0,119,362.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.14,261.29c0-.09-.18,0-.15.07,2.39,6.61,3.74,13.3,5.47,20.07a.25.25,0,0,0,.49-.08C110.25,274.48,107.8,267.63,105.14,261.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.81,289a101.34,101.34,0,0,1-5.49,11.29c-4.31,7.81-8.79,15-9.61,24.07-.36,4.06-.49,8.14-1.73,12a35.77,35.77,0,0,1-4.8,9.44c-4.66,6.79-10.49,12.65-14.81,19.7a82.73,82.73,0,0,0-9.85,23.73c-.1.46-.82.33-.72-.12a.45.45,0,0,0,0-.11.11.11,0,0,1,0-.09c-.69-19.51.87-39.17,6.82-57.86A200.25,200.25,0,0,1,135.06,307c3.19-6.77,7.16-13.29,12.76-18.35,3.63-3.27,11.5-9.47,16.67-6.19C167,284.06,166.79,286.55,165.81,289Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.21,333.21a161.87,161.87,0,0,1-11.34,16.3c-1.89,2.46-3.8,4.91-5.69,7.38-.89,1.16-1.89,2.32-2.71,3.58.52-2.05,1-4.11,1.54-6.16,2.52-9.85,4.94-19.8,8.69-29.27,3.66-9.27,8.54-18,13.54-26.56.14-.22-.23-.39-.36-.17-4.12,6.78-8.31,13.55-11.77,20.7a107.82,107.82,0,0,0-5,12.28,190.63,190.63,0,0,1,6.65-26.24c0-.08-.08-.13-.11-.05a89.54,89.54,0,0,0-6.91,27.29l0,0q-1.27,3.8-2.35,7.67c-3.07,10.91-5.77,21.94-8.27,33a118,118,0,0,1,1.88-21.7c0-.16-.22-.2-.26,0a68.84,68.84,0,0,0-1.88,22.87q-1.42,6.32-2.77,12.63c-1.91,9-4.27,18.15-5.39,27.28a.18.18,0,0,0,.36.06c1.34-4.92,2.15-10,3.24-15s2.23-10,3.39-15q2.55-10.89,5.28-21.73c1.21-2.65,3.54-5,5.29-7.22,1.92-2.44,3.84-4.88,5.71-7.36a109.48,109.48,0,0,0,9.39-14.53C146.44,333.18,146.27,333.11,146.21,333.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,324.87A101.76,101.76,0,0,0,136,342.49c0,.08.08.17.13.09,3.73-5.85,7.4-11.75,11.13-17.6C147.27,324.88,147.11,324.78,147,324.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,307.48c2.53,4.36,5.41,9.58,4.33,14.81-.69,3.31-3.11,6-3.55,9.37-1,7.45,6.44,12.38,11.82,15.9,13.39,8.79,31.76,16.62,34.2,34.57.09.64,1.19.48,1.11-.15a.26.26,0,0,0,0-.11s.07-.06.07-.11a68.93,68.93,0,0,0-.25-27.41c-2-9.25-6-17.56-10.8-25.69-8.06-13.75-16.6-27.84-28.79-38.37-3.37-2.91-10.28-8.16-13-1.58C56.53,295.11,60.9,302.17,64,307.48Z",
    style: {
      fill: "#58C475"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.26,336.64c8.88,9.61,23,15,30.64,25.77-4.53-16.5-12-31.35-23.55-44.24a.35.35,0,0,1,.49-.49,87.16,87.16,0,0,1,19.25,27.88,124.56,124.56,0,0,0-8.29-21.2.23.23,0,0,1,.39-.23A80.73,80.73,0,0,1,104.12,348c10.08,24.38,11,53,8.9,78.68,0,.37-.59.38-.58,0,.58-20.25.25-40.86-4.6-60.64-.1-.42-.22-.82-.32-1.23-8.32-11.6-22.38-17-31.42-28C76,336.69,76.16,336.53,76.26,336.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2,328.38c4.66,4.28,9.25,8.65,13.92,12.93,0,0,0,.12-.07.09a68.51,68.51,0,0,1-14.13-12.74A.2.2,0,0,1,74.2,328.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46,309.85a147.49,147.49,0,0,0,14,19.19.08.08,0,1,1-.12.11A67.63,67.63,0,0,1,73.21,310,.15.15,0,0,1,73.46,309.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.45 444.77 135.29 444.77 129.78 389.83 100.74 389.83 94.45 444.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.72 398.76 130.68 398.76 129.79 389.83 100.74 389.83 99.72 398.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.73,
    y: 383.74,
    width: 38.28,
    height: 8.77,
    transform: "translate(229.74 776.26) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.f1f8b08c7385477b31be54eff0580f54.svg";
export { ForwardRef as ReactComponent };